/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.BlackJack = (function() {

    /**
     * Namespace BlackJack.
     * @exports BlackJack
     * @namespace
     */
    var BlackJack = {};

    BlackJack.CardInfo = (function() {

        /**
         * Properties of a CardInfo.
         * @memberof BlackJack
         * @interface ICardInfo
         * @property {Array.<number>|null} [cards] CardInfo cards
         * @property {Array.<number>|null} [cardPoint] CardInfo cardPoint
         * @property {boolean|null} [doubleBet] CardInfo doubleBet
         * @property {boolean|null} [enableRight] CardInfo enableRight
         * @property {boolean|null} [moreCard] CardInfo moreCard
         * @property {boolean|null} [noMoreCard] CardInfo noMoreCard
         * @property {number|null} [status] CardInfo status
         */

        /**
         * Constructs a new CardInfo.
         * @memberof BlackJack
         * @classdesc Represents a CardInfo.
         * @implements ICardInfo
         * @constructor
         * @param {BlackJack.ICardInfo=} [properties] Properties to set
         */
        function CardInfo(properties) {
            this.cards = [];
            this.cardPoint = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CardInfo cards.
         * @member {Array.<number>} cards
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.cards = $util.emptyArray;

        /**
         * CardInfo cardPoint.
         * @member {Array.<number>} cardPoint
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.cardPoint = $util.emptyArray;

        /**
         * CardInfo doubleBet.
         * @member {boolean} doubleBet
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.doubleBet = false;

        /**
         * CardInfo enableRight.
         * @member {boolean} enableRight
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.enableRight = false;

        /**
         * CardInfo moreCard.
         * @member {boolean} moreCard
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.moreCard = false;

        /**
         * CardInfo noMoreCard.
         * @member {boolean} noMoreCard
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.noMoreCard = false;

        /**
         * CardInfo status.
         * @member {number} status
         * @memberof BlackJack.CardInfo
         * @instance
         */
        CardInfo.prototype.status = 0;

        /**
         * Creates a new CardInfo instance using the specified properties.
         * @function create
         * @memberof BlackJack.CardInfo
         * @static
         * @param {BlackJack.ICardInfo=} [properties] Properties to set
         * @returns {BlackJack.CardInfo} CardInfo instance
         */
        CardInfo.create = function create(properties) {
            return new CardInfo(properties);
        };

        /**
         * Encodes the specified CardInfo message. Does not implicitly {@link BlackJack.CardInfo.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.CardInfo
         * @static
         * @param {BlackJack.ICardInfo} message CardInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            if (message.cardPoint != null && message.cardPoint.length)
                for (var i = 0; i < message.cardPoint.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cardPoint[i]);
            if (message.doubleBet != null && message.hasOwnProperty("doubleBet"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.doubleBet);
            if (message.enableRight != null && message.hasOwnProperty("enableRight"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.enableRight);
            if (message.moreCard != null && message.hasOwnProperty("moreCard"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.moreCard);
            if (message.noMoreCard != null && message.hasOwnProperty("noMoreCard"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.noMoreCard);
            if (message.status != null && message.hasOwnProperty("status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified CardInfo message, length delimited. Does not implicitly {@link BlackJack.CardInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.CardInfo
         * @static
         * @param {BlackJack.ICardInfo} message CardInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CardInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CardInfo message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.CardInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.CardInfo} CardInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.CardInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 2:
                    if (!(message.cardPoint && message.cardPoint.length))
                        message.cardPoint = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cardPoint.push(reader.int32());
                    } else
                        message.cardPoint.push(reader.int32());
                    break;
                case 3:
                    message.doubleBet = reader.bool();
                    break;
                case 4:
                    message.enableRight = reader.bool();
                    break;
                case 5:
                    message.moreCard = reader.bool();
                    break;
                case 6:
                    message.noMoreCard = reader.bool();
                    break;
                case 7:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CardInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.CardInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.CardInfo} CardInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CardInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CardInfo message.
         * @function verify
         * @memberof BlackJack.CardInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CardInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint")) {
                if (!Array.isArray(message.cardPoint))
                    return "cardPoint: array expected";
                for (var i = 0; i < message.cardPoint.length; ++i)
                    if (!$util.isInteger(message.cardPoint[i]))
                        return "cardPoint: integer[] expected";
            }
            if (message.doubleBet != null && message.hasOwnProperty("doubleBet"))
                if (typeof message.doubleBet !== "boolean")
                    return "doubleBet: boolean expected";
            if (message.enableRight != null && message.hasOwnProperty("enableRight"))
                if (typeof message.enableRight !== "boolean")
                    return "enableRight: boolean expected";
            if (message.moreCard != null && message.hasOwnProperty("moreCard"))
                if (typeof message.moreCard !== "boolean")
                    return "moreCard: boolean expected";
            if (message.noMoreCard != null && message.hasOwnProperty("noMoreCard"))
                if (typeof message.noMoreCard !== "boolean")
                    return "noMoreCard: boolean expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            return null;
        };

        /**
         * Creates a CardInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.CardInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.CardInfo} CardInfo
         */
        CardInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.CardInfo)
                return object;
            var message = new $root.BlackJack.CardInfo();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".BlackJack.CardInfo.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.cardPoint) {
                if (!Array.isArray(object.cardPoint))
                    throw TypeError(".BlackJack.CardInfo.cardPoint: array expected");
                message.cardPoint = [];
                for (var i = 0; i < object.cardPoint.length; ++i)
                    message.cardPoint[i] = object.cardPoint[i] | 0;
            }
            if (object.doubleBet != null)
                message.doubleBet = Boolean(object.doubleBet);
            if (object.enableRight != null)
                message.enableRight = Boolean(object.enableRight);
            if (object.moreCard != null)
                message.moreCard = Boolean(object.moreCard);
            if (object.noMoreCard != null)
                message.noMoreCard = Boolean(object.noMoreCard);
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from a CardInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.CardInfo
         * @static
         * @param {BlackJack.CardInfo} message CardInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CardInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.cards = [];
                object.cardPoint = [];
            }
            if (options.defaults) {
                object.doubleBet = false;
                object.enableRight = false;
                object.moreCard = false;
                object.noMoreCard = false;
                object.status = 0;
            }
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.cardPoint && message.cardPoint.length) {
                object.cardPoint = [];
                for (var j = 0; j < message.cardPoint.length; ++j)
                    object.cardPoint[j] = message.cardPoint[j];
            }
            if (message.doubleBet != null && message.hasOwnProperty("doubleBet"))
                object.doubleBet = message.doubleBet;
            if (message.enableRight != null && message.hasOwnProperty("enableRight"))
                object.enableRight = message.enableRight;
            if (message.moreCard != null && message.hasOwnProperty("moreCard"))
                object.moreCard = message.moreCard;
            if (message.noMoreCard != null && message.hasOwnProperty("noMoreCard"))
                object.noMoreCard = message.noMoreCard;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this CardInfo to JSON.
         * @function toJSON
         * @memberof BlackJack.CardInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CardInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CardInfo;
    })();

    BlackJack.Player = (function() {

        /**
         * Properties of a Player.
         * @memberof BlackJack
         * @interface IPlayer
         * @property {number|null} [playerId] Player playerId
         * @property {number|null} [playerPos] Player playerPos
         * @property {number|null} [coinBalance] Player coinBalance
         * @property {number|null} [latestBetPos] Player latestBetPos
         * @property {number|null} [totalBalance] Player totalBalance
         * @property {Array.<BlackJack.Player.IBetInfo>|null} [betInfo] Player betInfo
         * @property {BlackJack.Player.IBetInfo|null} [historyBetInfo] Player historyBetInfo
         */

        /**
         * Constructs a new Player.
         * @memberof BlackJack
         * @classdesc Represents a Player.
         * @implements IPlayer
         * @constructor
         * @param {BlackJack.IPlayer=} [properties] Properties to set
         */
        function Player(properties) {
            this.betInfo = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Player playerId.
         * @member {number} playerId
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.playerId = 0;

        /**
         * Player playerPos.
         * @member {number} playerPos
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.playerPos = 0;

        /**
         * Player coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.coinBalance = 0;

        /**
         * Player latestBetPos.
         * @member {number} latestBetPos
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.latestBetPos = 0;

        /**
         * Player totalBalance.
         * @member {number} totalBalance
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.totalBalance = 0;

        /**
         * Player betInfo.
         * @member {Array.<BlackJack.Player.IBetInfo>} betInfo
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.betInfo = $util.emptyArray;

        /**
         * Player historyBetInfo.
         * @member {BlackJack.Player.IBetInfo|null|undefined} historyBetInfo
         * @memberof BlackJack.Player
         * @instance
         */
        Player.prototype.historyBetInfo = null;

        /**
         * Creates a new Player instance using the specified properties.
         * @function create
         * @memberof BlackJack.Player
         * @static
         * @param {BlackJack.IPlayer=} [properties] Properties to set
         * @returns {BlackJack.Player} Player instance
         */
        Player.create = function create(properties) {
            return new Player(properties);
        };

        /**
         * Encodes the specified Player message. Does not implicitly {@link BlackJack.Player.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.Player
         * @static
         * @param {BlackJack.IPlayer} message Player message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Player.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.playerPos);
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.totalBalance);
            if (message.latestBetPos != null && message.hasOwnProperty("latestBetPos"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.latestBetPos);
            if (message.betInfo != null && message.betInfo.length)
                for (var i = 0; i < message.betInfo.length; ++i)
                    $root.BlackJack.Player.BetInfo.encode(message.betInfo[i], writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.historyBetInfo != null && message.hasOwnProperty("historyBetInfo"))
                $root.BlackJack.Player.BetInfo.encode(message.historyBetInfo, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 20, wireType 1 =*/161).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified Player message, length delimited. Does not implicitly {@link BlackJack.Player.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.Player
         * @static
         * @param {BlackJack.IPlayer} message Player message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Player.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Player message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.Player
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.Player} Player
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Player.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.Player();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.playerPos = reader.uint32();
                    break;
                case 20:
                    message.coinBalance = reader.double();
                    break;
                case 13:
                    message.latestBetPos = reader.int32();
                    break;
                case 11:
                    message.totalBalance = reader.double();
                    break;
                case 17:
                    if (!(message.betInfo && message.betInfo.length))
                        message.betInfo = [];
                    message.betInfo.push($root.BlackJack.Player.BetInfo.decode(reader, reader.uint32()));
                    break;
                case 18:
                    message.historyBetInfo = $root.BlackJack.Player.BetInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Player message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.Player
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.Player} Player
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Player.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Player message.
         * @function verify
         * @memberof BlackJack.Player
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Player.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                if (!$util.isInteger(message.playerPos))
                    return "playerPos: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.latestBetPos != null && message.hasOwnProperty("latestBetPos"))
                if (!$util.isInteger(message.latestBetPos))
                    return "latestBetPos: integer expected";
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                if (typeof message.totalBalance !== "number")
                    return "totalBalance: number expected";
            if (message.betInfo != null && message.hasOwnProperty("betInfo")) {
                if (!Array.isArray(message.betInfo))
                    return "betInfo: array expected";
                for (var i = 0; i < message.betInfo.length; ++i) {
                    var error = $root.BlackJack.Player.BetInfo.verify(message.betInfo[i]);
                    if (error)
                        return "betInfo." + error;
                }
            }
            if (message.historyBetInfo != null && message.hasOwnProperty("historyBetInfo")) {
                var error = $root.BlackJack.Player.BetInfo.verify(message.historyBetInfo);
                if (error)
                    return "historyBetInfo." + error;
            }
            return null;
        };

        /**
         * Creates a Player message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.Player
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.Player} Player
         */
        Player.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.Player)
                return object;
            var message = new $root.BlackJack.Player();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.playerPos != null)
                message.playerPos = object.playerPos >>> 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.latestBetPos != null)
                message.latestBetPos = object.latestBetPos | 0;
            if (object.totalBalance != null)
                message.totalBalance = Number(object.totalBalance);
            if (object.betInfo) {
                if (!Array.isArray(object.betInfo))
                    throw TypeError(".BlackJack.Player.betInfo: array expected");
                message.betInfo = [];
                for (var i = 0; i < object.betInfo.length; ++i) {
                    if (typeof object.betInfo[i] !== "object")
                        throw TypeError(".BlackJack.Player.betInfo: object expected");
                    message.betInfo[i] = $root.BlackJack.Player.BetInfo.fromObject(object.betInfo[i]);
                }
            }
            if (object.historyBetInfo != null) {
                if (typeof object.historyBetInfo !== "object")
                    throw TypeError(".BlackJack.Player.historyBetInfo: object expected");
                message.historyBetInfo = $root.BlackJack.Player.BetInfo.fromObject(object.historyBetInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a Player message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.Player
         * @static
         * @param {BlackJack.Player} message Player
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Player.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.betInfo = [];
            if (options.defaults) {
                object.playerId = 0;
                object.playerPos = 0;
                object.totalBalance = 0;
                object.latestBetPos = 0;
                object.historyBetInfo = null;
                object.coinBalance = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                object.playerPos = message.playerPos;
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                object.totalBalance = options.json && !isFinite(message.totalBalance) ? String(message.totalBalance) : message.totalBalance;
            if (message.latestBetPos != null && message.hasOwnProperty("latestBetPos"))
                object.latestBetPos = message.latestBetPos;
            if (message.betInfo && message.betInfo.length) {
                object.betInfo = [];
                for (var j = 0; j < message.betInfo.length; ++j)
                    object.betInfo[j] = $root.BlackJack.Player.BetInfo.toObject(message.betInfo[j], options);
            }
            if (message.historyBetInfo != null && message.hasOwnProperty("historyBetInfo"))
                object.historyBetInfo = $root.BlackJack.Player.BetInfo.toObject(message.historyBetInfo, options);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this Player to JSON.
         * @function toJSON
         * @memberof BlackJack.Player
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Player.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Player.BetInfo = (function() {

            /**
             * Properties of a BetInfo.
             * @memberof BlackJack.Player
             * @interface IBetInfo
             * @property {number|null} [pos] BetInfo pos
             * @property {number|null} [base] BetInfo base
             * @property {number|null} [pair] BetInfo pair
             * @property {number|null} [b21p3] BetInfo b21p3
             */

            /**
             * Constructs a new BetInfo.
             * @memberof BlackJack.Player
             * @classdesc Represents a BetInfo.
             * @implements IBetInfo
             * @constructor
             * @param {BlackJack.Player.IBetInfo=} [properties] Properties to set
             */
            function BetInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetInfo pos.
             * @member {number} pos
             * @memberof BlackJack.Player.BetInfo
             * @instance
             */
            BetInfo.prototype.pos = 0;

            /**
             * BetInfo base.
             * @member {number} base
             * @memberof BlackJack.Player.BetInfo
             * @instance
             */
            BetInfo.prototype.base = 0;

            /**
             * BetInfo pair.
             * @member {number} pair
             * @memberof BlackJack.Player.BetInfo
             * @instance
             */
            BetInfo.prototype.pair = 0;

            /**
             * BetInfo b21p3.
             * @member {number} b21p3
             * @memberof BlackJack.Player.BetInfo
             * @instance
             */
            BetInfo.prototype.b21p3 = 0;

            /**
             * Creates a new BetInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {BlackJack.Player.IBetInfo=} [properties] Properties to set
             * @returns {BlackJack.Player.BetInfo} BetInfo instance
             */
            BetInfo.create = function create(properties) {
                return new BetInfo(properties);
            };

            /**
             * Encodes the specified BetInfo message. Does not implicitly {@link BlackJack.Player.BetInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {BlackJack.Player.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
                if (message.base != null && message.hasOwnProperty("base"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.base);
                if (message.pair != null && message.hasOwnProperty("pair"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.pair);
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.b21p3);
                return writer;
            };

            /**
             * Encodes the specified BetInfo message, length delimited. Does not implicitly {@link BlackJack.Player.BetInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {BlackJack.Player.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.Player.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.Player.BetInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.uint32();
                        break;
                    case 2:
                        message.base = reader.double();
                        break;
                    case 3:
                        message.pair = reader.double();
                        break;
                    case 4:
                        message.b21p3 = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.Player.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetInfo message.
             * @function verify
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.base != null && message.hasOwnProperty("base"))
                    if (typeof message.base !== "number")
                        return "base: number expected";
                if (message.pair != null && message.hasOwnProperty("pair"))
                    if (typeof message.pair !== "number")
                        return "pair: number expected";
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    if (typeof message.b21p3 !== "number")
                        return "b21p3: number expected";
                return null;
            };

            /**
             * Creates a BetInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.Player.BetInfo} BetInfo
             */
            BetInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.Player.BetInfo)
                    return object;
                var message = new $root.BlackJack.Player.BetInfo();
                if (object.pos != null)
                    message.pos = object.pos >>> 0;
                if (object.base != null)
                    message.base = Number(object.base);
                if (object.pair != null)
                    message.pair = Number(object.pair);
                if (object.b21p3 != null)
                    message.b21p3 = Number(object.b21p3);
                return message;
            };

            /**
             * Creates a plain object from a BetInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.Player.BetInfo
             * @static
             * @param {BlackJack.Player.BetInfo} message BetInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.pos = 0;
                    object.base = 0;
                    object.pair = 0;
                    object.b21p3 = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.base != null && message.hasOwnProperty("base"))
                    object.base = options.json && !isFinite(message.base) ? String(message.base) : message.base;
                if (message.pair != null && message.hasOwnProperty("pair"))
                    object.pair = options.json && !isFinite(message.pair) ? String(message.pair) : message.pair;
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    object.b21p3 = options.json && !isFinite(message.b21p3) ? String(message.b21p3) : message.b21p3;
                return object;
            };

            /**
             * Converts this BetInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.Player.BetInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BetInfo;
        })();

        return Player;
    })();

    BlackJack.PosInfo = (function() {

        /**
         * Properties of a PosInfo.
         * @memberof BlackJack
         * @interface IPosInfo
         * @property {number|null} [pos] PosInfo pos
         * @property {number|null} [playerId] PosInfo playerId
         * @property {number|null} [insurance] PosInfo insurance
         * @property {boolean|null} [insuranceFlag] PosInfo insuranceFlag
         * @property {number|null} [base] PosInfo base
         * @property {number|null} [pair] PosInfo pair
         * @property {number|null} [b21p3] PosInfo b21p3
         * @property {number|null} [coinBalance] PosInfo coinBalance
         * @property {boolean|null} [isMainSeat] PosInfo isMainSeat
         * @property {BlackJack.ICardInfo|null} [cardInfo] PosInfo cardInfo
         * @property {boolean|null} [betFinish] PosInfo betFinish
         * @property {number|null} [totalBalance] PosInfo totalBalance
         * @property {string|null} [userJson] PosInfo userJson
         */

        /**
         * Constructs a new PosInfo.
         * @memberof BlackJack
         * @classdesc Represents a PosInfo.
         * @implements IPosInfo
         * @constructor
         * @param {BlackJack.IPosInfo=} [properties] Properties to set
         */
        function PosInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PosInfo pos.
         * @member {number} pos
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.pos = 0;

        /**
         * PosInfo playerId.
         * @member {number} playerId
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.playerId = 0;

        /**
         * PosInfo insurance.
         * @member {number} insurance
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.insurance = 0;

        /**
         * PosInfo insuranceFlag.
         * @member {boolean} insuranceFlag
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.insuranceFlag = false;

        /**
         * PosInfo base.
         * @member {number} base
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.base = 0;

        /**
         * PosInfo pair.
         * @member {number} pair
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.pair = 0;

        /**
         * PosInfo b21p3.
         * @member {number} b21p3
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.b21p3 = 0;

        /**
         * PosInfo coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.coinBalance = 0;

        /**
         * PosInfo isMainSeat.
         * @member {boolean} isMainSeat
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.isMainSeat = false;

        /**
         * PosInfo cardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} cardInfo
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.cardInfo = null;

        /**
         * PosInfo betFinish.
         * @member {boolean} betFinish
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.betFinish = false;

        /**
         * PosInfo totalBalance.
         * @member {number} totalBalance
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.totalBalance = 0;

        /**
         * PosInfo userJson.
         * @member {string} userJson
         * @memberof BlackJack.PosInfo
         * @instance
         */
        PosInfo.prototype.userJson = "";

        /**
         * Creates a new PosInfo instance using the specified properties.
         * @function create
         * @memberof BlackJack.PosInfo
         * @static
         * @param {BlackJack.IPosInfo=} [properties] Properties to set
         * @returns {BlackJack.PosInfo} PosInfo instance
         */
        PosInfo.create = function create(properties) {
            return new PosInfo(properties);
        };

        /**
         * Encodes the specified PosInfo message. Does not implicitly {@link BlackJack.PosInfo.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.PosInfo
         * @static
         * @param {BlackJack.IPosInfo} message PosInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PosInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.base != null && message.hasOwnProperty("base"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.base);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.insurance);
            if (message.insuranceFlag != null && message.hasOwnProperty("insuranceFlag"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.insuranceFlag);
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                $root.BlackJack.CardInfo.encode(message.cardInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.pair != null && message.hasOwnProperty("pair"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.pair);
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.b21p3);
            if (message.isMainSeat != null && message.hasOwnProperty("isMainSeat"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isMainSeat);
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.totalBalance);
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.userJson);
            if (message.betFinish != null && message.hasOwnProperty("betFinish"))
                writer.uint32(/* id 15, wireType 0 =*/120).bool(message.betFinish);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 20, wireType 1 =*/161).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified PosInfo message, length delimited. Does not implicitly {@link BlackJack.PosInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.PosInfo
         * @static
         * @param {BlackJack.IPosInfo} message PosInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PosInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PosInfo message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.PosInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.PosInfo} PosInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PosInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.PosInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 4:
                    message.insurance = reader.int32();
                    break;
                case 5:
                    message.insuranceFlag = reader.bool();
                    break;
                case 2:
                    message.base = reader.double();
                    break;
                case 7:
                    message.pair = reader.double();
                    break;
                case 8:
                    message.b21p3 = reader.double();
                    break;
                case 20:
                    message.coinBalance = reader.double();
                    break;
                case 9:
                    message.isMainSeat = reader.bool();
                    break;
                case 6:
                    message.cardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.betFinish = reader.bool();
                    break;
                case 11:
                    message.totalBalance = reader.double();
                    break;
                case 13:
                    message.userJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PosInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.PosInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.PosInfo} PosInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PosInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PosInfo message.
         * @function verify
         * @memberof BlackJack.PosInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PosInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                if (!$util.isInteger(message.insurance))
                    return "insurance: integer expected";
            if (message.insuranceFlag != null && message.hasOwnProperty("insuranceFlag"))
                if (typeof message.insuranceFlag !== "boolean")
                    return "insuranceFlag: boolean expected";
            if (message.base != null && message.hasOwnProperty("base"))
                if (typeof message.base !== "number")
                    return "base: number expected";
            if (message.pair != null && message.hasOwnProperty("pair"))
                if (typeof message.pair !== "number")
                    return "pair: number expected";
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                if (typeof message.b21p3 !== "number")
                    return "b21p3: number expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.isMainSeat != null && message.hasOwnProperty("isMainSeat"))
                if (typeof message.isMainSeat !== "boolean")
                    return "isMainSeat: boolean expected";
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.cardInfo);
                if (error)
                    return "cardInfo." + error;
            }
            if (message.betFinish != null && message.hasOwnProperty("betFinish"))
                if (typeof message.betFinish !== "boolean")
                    return "betFinish: boolean expected";
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                if (typeof message.totalBalance !== "number")
                    return "totalBalance: number expected";
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                if (!$util.isString(message.userJson))
                    return "userJson: string expected";
            return null;
        };

        /**
         * Creates a PosInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.PosInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.PosInfo} PosInfo
         */
        PosInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.PosInfo)
                return object;
            var message = new $root.BlackJack.PosInfo();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.insurance != null)
                message.insurance = object.insurance | 0;
            if (object.insuranceFlag != null)
                message.insuranceFlag = Boolean(object.insuranceFlag);
            if (object.base != null)
                message.base = Number(object.base);
            if (object.pair != null)
                message.pair = Number(object.pair);
            if (object.b21p3 != null)
                message.b21p3 = Number(object.b21p3);
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.isMainSeat != null)
                message.isMainSeat = Boolean(object.isMainSeat);
            if (object.cardInfo != null) {
                if (typeof object.cardInfo !== "object")
                    throw TypeError(".BlackJack.PosInfo.cardInfo: object expected");
                message.cardInfo = $root.BlackJack.CardInfo.fromObject(object.cardInfo);
            }
            if (object.betFinish != null)
                message.betFinish = Boolean(object.betFinish);
            if (object.totalBalance != null)
                message.totalBalance = Number(object.totalBalance);
            if (object.userJson != null)
                message.userJson = String(object.userJson);
            return message;
        };

        /**
         * Creates a plain object from a PosInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.PosInfo
         * @static
         * @param {BlackJack.PosInfo} message PosInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PosInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.base = 0;
                object.playerId = 0;
                object.insurance = 0;
                object.insuranceFlag = false;
                object.cardInfo = null;
                object.pair = 0;
                object.b21p3 = 0;
                object.isMainSeat = false;
                object.totalBalance = 0;
                object.userJson = "";
                object.betFinish = false;
                object.coinBalance = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.base != null && message.hasOwnProperty("base"))
                object.base = options.json && !isFinite(message.base) ? String(message.base) : message.base;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                object.insurance = message.insurance;
            if (message.insuranceFlag != null && message.hasOwnProperty("insuranceFlag"))
                object.insuranceFlag = message.insuranceFlag;
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                object.cardInfo = $root.BlackJack.CardInfo.toObject(message.cardInfo, options);
            if (message.pair != null && message.hasOwnProperty("pair"))
                object.pair = options.json && !isFinite(message.pair) ? String(message.pair) : message.pair;
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                object.b21p3 = options.json && !isFinite(message.b21p3) ? String(message.b21p3) : message.b21p3;
            if (message.isMainSeat != null && message.hasOwnProperty("isMainSeat"))
                object.isMainSeat = message.isMainSeat;
            if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                object.totalBalance = options.json && !isFinite(message.totalBalance) ? String(message.totalBalance) : message.totalBalance;
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                object.userJson = message.userJson;
            if (message.betFinish != null && message.hasOwnProperty("betFinish"))
                object.betFinish = message.betFinish;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this PosInfo to JSON.
         * @function toJSON
         * @memberof BlackJack.PosInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PosInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PosInfo;
    })();

    BlackJack.GameInfo = (function() {

        /**
         * Properties of a GameInfo.
         * @memberof BlackJack
         * @interface IGameInfo
         * @property {number|null} [roomId] GameInfo roomId
         * @property {BlackJack.IPlayer|null} [mainPlayer] GameInfo mainPlayer
         * @property {number|null} [time] GameInfo time
         * @property {number|null} [maxPlayerCnt] GameInfo maxPlayerCnt
         * @property {string|null} [stageDesc] GameInfo stageDesc
         * @property {number|null} [feeNum] GameInfo feeNum
         * @property {number|null} [baseCoinScore] GameInfo baseCoinScore
         * @property {Array.<number>|null} [bankerCards] GameInfo bankerCards
         * @property {number|null} [bankerCardPoint] GameInfo bankerCardPoint
         * @property {number|null} [state] GameInfo state
         * @property {number|null} [stateExpiredTime] GameInfo stateExpiredTime
         * @property {number|null} [stateDuration] GameInfo stateDuration
         * @property {number|null} [currentPos] GameInfo currentPos
         * @property {Array.<BlackJack.IPosInfo>|null} [posInfo] GameInfo posInfo
         * @property {string|null} [roundSign] GameInfo roundSign
         */

        /**
         * Constructs a new GameInfo.
         * @memberof BlackJack
         * @classdesc Represents a GameInfo.
         * @implements IGameInfo
         * @constructor
         * @param {BlackJack.IGameInfo=} [properties] Properties to set
         */
        function GameInfo(properties) {
            this.bankerCards = [];
            this.posInfo = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameInfo roomId.
         * @member {number} roomId
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.roomId = 0;

        /**
         * GameInfo mainPlayer.
         * @member {BlackJack.IPlayer|null|undefined} mainPlayer
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.mainPlayer = null;

        /**
         * GameInfo time.
         * @member {number} time
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.time = 0;

        /**
         * GameInfo maxPlayerCnt.
         * @member {number} maxPlayerCnt
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.maxPlayerCnt = 0;

        /**
         * GameInfo stageDesc.
         * @member {string} stageDesc
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.stageDesc = "";

        /**
         * GameInfo feeNum.
         * @member {number} feeNum
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.feeNum = 0;

        /**
         * GameInfo baseCoinScore.
         * @member {number} baseCoinScore
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.baseCoinScore = 0;

        /**
         * GameInfo bankerCards.
         * @member {Array.<number>} bankerCards
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.bankerCards = $util.emptyArray;

        /**
         * GameInfo bankerCardPoint.
         * @member {number} bankerCardPoint
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.bankerCardPoint = 0;

        /**
         * GameInfo state.
         * @member {number} state
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.state = 0;

        /**
         * GameInfo stateExpiredTime.
         * @member {number} stateExpiredTime
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.stateExpiredTime = 0;

        /**
         * GameInfo stateDuration.
         * @member {number} stateDuration
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.stateDuration = 0;

        /**
         * GameInfo currentPos.
         * @member {number} currentPos
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.currentPos = 0;

        /**
         * GameInfo posInfo.
         * @member {Array.<BlackJack.IPosInfo>} posInfo
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.posInfo = $util.emptyArray;

        /**
         * GameInfo roundSign.
         * @member {string} roundSign
         * @memberof BlackJack.GameInfo
         * @instance
         */
        GameInfo.prototype.roundSign = "";

        /**
         * Creates a new GameInfo instance using the specified properties.
         * @function create
         * @memberof BlackJack.GameInfo
         * @static
         * @param {BlackJack.IGameInfo=} [properties] Properties to set
         * @returns {BlackJack.GameInfo} GameInfo instance
         */
        GameInfo.create = function create(properties) {
            return new GameInfo(properties);
        };

        /**
         * Encodes the specified GameInfo message. Does not implicitly {@link BlackJack.GameInfo.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.GameInfo
         * @static
         * @param {BlackJack.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            if (message.mainPlayer != null && message.hasOwnProperty("mainPlayer"))
                $root.BlackJack.Player.encode(message.mainPlayer, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.time != null && message.hasOwnProperty("time"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.time);
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxPlayerCnt);
            if (message.stageDesc != null && message.hasOwnProperty("stageDesc"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.stageDesc);
            if (message.feeNum != null && message.hasOwnProperty("feeNum"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.feeNum);
            if (message.baseCoinScore != null && message.hasOwnProperty("baseCoinScore"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.baseCoinScore);
            if (message.bankerCards != null && message.bankerCards.length)
                for (var i = 0; i < message.bankerCards.length; ++i)
                    writer.uint32(/* id 8, wireType 0 =*/64).int32(message.bankerCards[i]);
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.bankerCardPoint);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.state);
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.stateExpiredTime);
            if (message.currentPos != null && message.hasOwnProperty("currentPos"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.currentPos);
            if (message.posInfo != null && message.posInfo.length)
                for (var i = 0; i < message.posInfo.length; ++i)
                    $root.BlackJack.PosInfo.encode(message.posInfo[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.stateDuration);
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.roundSign);
            return writer;
        };

        /**
         * Encodes the specified GameInfo message, length delimited. Does not implicitly {@link BlackJack.GameInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.GameInfo
         * @static
         * @param {BlackJack.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.GameInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 2:
                    message.mainPlayer = $root.BlackJack.Player.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.time = reader.int32();
                    break;
                case 4:
                    message.maxPlayerCnt = reader.int32();
                    break;
                case 5:
                    message.stageDesc = reader.string();
                    break;
                case 6:
                    message.feeNum = reader.int32();
                    break;
                case 7:
                    message.baseCoinScore = reader.int32();
                    break;
                case 8:
                    if (!(message.bankerCards && message.bankerCards.length))
                        message.bankerCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.bankerCards.push(reader.int32());
                    } else
                        message.bankerCards.push(reader.int32());
                    break;
                case 9:
                    message.bankerCardPoint = reader.int32();
                    break;
                case 10:
                    message.state = reader.int32();
                    break;
                case 11:
                    message.stateExpiredTime = reader.int32();
                    break;
                case 14:
                    message.stateDuration = reader.int32();
                    break;
                case 12:
                    message.currentPos = reader.int32();
                    break;
                case 13:
                    if (!(message.posInfo && message.posInfo.length))
                        message.posInfo = [];
                    message.posInfo.push($root.BlackJack.PosInfo.decode(reader, reader.uint32()));
                    break;
                case 15:
                    message.roundSign = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameInfo message.
         * @function verify
         * @memberof BlackJack.GameInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isInteger(message.roomId))
                    return "roomId: integer expected";
            if (message.mainPlayer != null && message.hasOwnProperty("mainPlayer")) {
                var error = $root.BlackJack.Player.verify(message.mainPlayer);
                if (error)
                    return "mainPlayer." + error;
            }
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                if (!$util.isInteger(message.maxPlayerCnt))
                    return "maxPlayerCnt: integer expected";
            if (message.stageDesc != null && message.hasOwnProperty("stageDesc"))
                if (!$util.isString(message.stageDesc))
                    return "stageDesc: string expected";
            if (message.feeNum != null && message.hasOwnProperty("feeNum"))
                if (!$util.isInteger(message.feeNum))
                    return "feeNum: integer expected";
            if (message.baseCoinScore != null && message.hasOwnProperty("baseCoinScore"))
                if (!$util.isInteger(message.baseCoinScore))
                    return "baseCoinScore: integer expected";
            if (message.bankerCards != null && message.hasOwnProperty("bankerCards")) {
                if (!Array.isArray(message.bankerCards))
                    return "bankerCards: array expected";
                for (var i = 0; i < message.bankerCards.length; ++i)
                    if (!$util.isInteger(message.bankerCards[i]))
                        return "bankerCards: integer[] expected";
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                if (!$util.isInteger(message.bankerCardPoint))
                    return "bankerCardPoint: integer expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                if (!$util.isInteger(message.stateExpiredTime))
                    return "stateExpiredTime: integer expected";
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                if (!$util.isInteger(message.stateDuration))
                    return "stateDuration: integer expected";
            if (message.currentPos != null && message.hasOwnProperty("currentPos"))
                if (!$util.isInteger(message.currentPos))
                    return "currentPos: integer expected";
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                if (!Array.isArray(message.posInfo))
                    return "posInfo: array expected";
                for (var i = 0; i < message.posInfo.length; ++i) {
                    var error = $root.BlackJack.PosInfo.verify(message.posInfo[i]);
                    if (error)
                        return "posInfo." + error;
                }
            }
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                if (!$util.isString(message.roundSign))
                    return "roundSign: string expected";
            return null;
        };

        /**
         * Creates a GameInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.GameInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.GameInfo} GameInfo
         */
        GameInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.GameInfo)
                return object;
            var message = new $root.BlackJack.GameInfo();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.mainPlayer != null) {
                if (typeof object.mainPlayer !== "object")
                    throw TypeError(".BlackJack.GameInfo.mainPlayer: object expected");
                message.mainPlayer = $root.BlackJack.Player.fromObject(object.mainPlayer);
            }
            if (object.time != null)
                message.time = object.time | 0;
            if (object.maxPlayerCnt != null)
                message.maxPlayerCnt = object.maxPlayerCnt | 0;
            if (object.stageDesc != null)
                message.stageDesc = String(object.stageDesc);
            if (object.feeNum != null)
                message.feeNum = object.feeNum | 0;
            if (object.baseCoinScore != null)
                message.baseCoinScore = object.baseCoinScore | 0;
            if (object.bankerCards) {
                if (!Array.isArray(object.bankerCards))
                    throw TypeError(".BlackJack.GameInfo.bankerCards: array expected");
                message.bankerCards = [];
                for (var i = 0; i < object.bankerCards.length; ++i)
                    message.bankerCards[i] = object.bankerCards[i] | 0;
            }
            if (object.bankerCardPoint != null)
                message.bankerCardPoint = object.bankerCardPoint | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.stateExpiredTime != null)
                message.stateExpiredTime = object.stateExpiredTime | 0;
            if (object.stateDuration != null)
                message.stateDuration = object.stateDuration | 0;
            if (object.currentPos != null)
                message.currentPos = object.currentPos | 0;
            if (object.posInfo) {
                if (!Array.isArray(object.posInfo))
                    throw TypeError(".BlackJack.GameInfo.posInfo: array expected");
                message.posInfo = [];
                for (var i = 0; i < object.posInfo.length; ++i) {
                    if (typeof object.posInfo[i] !== "object")
                        throw TypeError(".BlackJack.GameInfo.posInfo: object expected");
                    message.posInfo[i] = $root.BlackJack.PosInfo.fromObject(object.posInfo[i]);
                }
            }
            if (object.roundSign != null)
                message.roundSign = String(object.roundSign);
            return message;
        };

        /**
         * Creates a plain object from a GameInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.GameInfo
         * @static
         * @param {BlackJack.GameInfo} message GameInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.bankerCards = [];
                object.posInfo = [];
            }
            if (options.defaults) {
                object.roomId = 0;
                object.mainPlayer = null;
                object.time = 0;
                object.maxPlayerCnt = 0;
                object.stageDesc = "";
                object.feeNum = 0;
                object.baseCoinScore = 0;
                object.bankerCardPoint = 0;
                object.state = 0;
                object.stateExpiredTime = 0;
                object.currentPos = 0;
                object.stateDuration = 0;
                object.roundSign = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.mainPlayer != null && message.hasOwnProperty("mainPlayer"))
                object.mainPlayer = $root.BlackJack.Player.toObject(message.mainPlayer, options);
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.maxPlayerCnt != null && message.hasOwnProperty("maxPlayerCnt"))
                object.maxPlayerCnt = message.maxPlayerCnt;
            if (message.stageDesc != null && message.hasOwnProperty("stageDesc"))
                object.stageDesc = message.stageDesc;
            if (message.feeNum != null && message.hasOwnProperty("feeNum"))
                object.feeNum = message.feeNum;
            if (message.baseCoinScore != null && message.hasOwnProperty("baseCoinScore"))
                object.baseCoinScore = message.baseCoinScore;
            if (message.bankerCards && message.bankerCards.length) {
                object.bankerCards = [];
                for (var j = 0; j < message.bankerCards.length; ++j)
                    object.bankerCards[j] = message.bankerCards[j];
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                object.bankerCardPoint = message.bankerCardPoint;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.stateExpiredTime != null && message.hasOwnProperty("stateExpiredTime"))
                object.stateExpiredTime = message.stateExpiredTime;
            if (message.currentPos != null && message.hasOwnProperty("currentPos"))
                object.currentPos = message.currentPos;
            if (message.posInfo && message.posInfo.length) {
                object.posInfo = [];
                for (var j = 0; j < message.posInfo.length; ++j)
                    object.posInfo[j] = $root.BlackJack.PosInfo.toObject(message.posInfo[j], options);
            }
            if (message.stateDuration != null && message.hasOwnProperty("stateDuration"))
                object.stateDuration = message.stateDuration;
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                object.roundSign = message.roundSign;
            return object;
        };

        /**
         * Converts this GameInfo to JSON.
         * @function toJSON
         * @memberof BlackJack.GameInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameInfo;
    })();

    BlackJack.BetReq = (function() {

        /**
         * Properties of a BetReq.
         * @memberof BlackJack
         * @interface IBetReq
         * @property {number|null} [pos] BetReq pos
         * @property {number|null} [betType] BetReq betType
         * @property {boolean|null} [autoFollowDouble] BetReq autoFollowDouble
         * @property {boolean|null} [autoFollowRight] BetReq autoFollowRight
         * @property {number|null} [bet] BetReq bet
         */

        /**
         * Constructs a new BetReq.
         * @memberof BlackJack
         * @classdesc Represents a BetReq.
         * @implements IBetReq
         * @constructor
         * @param {BlackJack.IBetReq=} [properties] Properties to set
         */
        function BetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetReq pos.
         * @member {number} pos
         * @memberof BlackJack.BetReq
         * @instance
         */
        BetReq.prototype.pos = 0;

        /**
         * BetReq betType.
         * @member {number} betType
         * @memberof BlackJack.BetReq
         * @instance
         */
        BetReq.prototype.betType = 0;

        /**
         * BetReq autoFollowDouble.
         * @member {boolean} autoFollowDouble
         * @memberof BlackJack.BetReq
         * @instance
         */
        BetReq.prototype.autoFollowDouble = false;

        /**
         * BetReq autoFollowRight.
         * @member {boolean} autoFollowRight
         * @memberof BlackJack.BetReq
         * @instance
         */
        BetReq.prototype.autoFollowRight = false;

        /**
         * BetReq bet.
         * @member {number} bet
         * @memberof BlackJack.BetReq
         * @instance
         */
        BetReq.prototype.bet = 0;

        /**
         * Creates a new BetReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetReq
         * @static
         * @param {BlackJack.IBetReq=} [properties] Properties to set
         * @returns {BlackJack.BetReq} BetReq instance
         */
        BetReq.create = function create(properties) {
            return new BetReq(properties);
        };

        /**
         * Encodes the specified BetReq message. Does not implicitly {@link BlackJack.BetReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetReq
         * @static
         * @param {BlackJack.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.betType != null && message.hasOwnProperty("betType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.betType);
            if (message.autoFollowDouble != null && message.hasOwnProperty("autoFollowDouble"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.autoFollowDouble);
            if (message.autoFollowRight != null && message.hasOwnProperty("autoFollowRight"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.autoFollowRight);
            if (message.bet != null && message.hasOwnProperty("bet"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.bet);
            return writer;
        };

        /**
         * Encodes the specified BetReq message, length delimited. Does not implicitly {@link BlackJack.BetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetReq
         * @static
         * @param {BlackJack.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.betType = reader.int32();
                    break;
                case 3:
                    message.autoFollowDouble = reader.bool();
                    break;
                case 4:
                    message.autoFollowRight = reader.bool();
                    break;
                case 5:
                    message.bet = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetReq message.
         * @function verify
         * @memberof BlackJack.BetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.betType != null && message.hasOwnProperty("betType"))
                if (!$util.isInteger(message.betType))
                    return "betType: integer expected";
            if (message.autoFollowDouble != null && message.hasOwnProperty("autoFollowDouble"))
                if (typeof message.autoFollowDouble !== "boolean")
                    return "autoFollowDouble: boolean expected";
            if (message.autoFollowRight != null && message.hasOwnProperty("autoFollowRight"))
                if (typeof message.autoFollowRight !== "boolean")
                    return "autoFollowRight: boolean expected";
            if (message.bet != null && message.hasOwnProperty("bet"))
                if (typeof message.bet !== "number")
                    return "bet: number expected";
            return null;
        };

        /**
         * Creates a BetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetReq} BetReq
         */
        BetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetReq)
                return object;
            var message = new $root.BlackJack.BetReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.betType != null)
                message.betType = object.betType | 0;
            if (object.autoFollowDouble != null)
                message.autoFollowDouble = Boolean(object.autoFollowDouble);
            if (object.autoFollowRight != null)
                message.autoFollowRight = Boolean(object.autoFollowRight);
            if (object.bet != null)
                message.bet = Number(object.bet);
            return message;
        };

        /**
         * Creates a plain object from a BetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetReq
         * @static
         * @param {BlackJack.BetReq} message BetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.betType = 0;
                object.autoFollowDouble = false;
                object.autoFollowRight = false;
                object.bet = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.betType != null && message.hasOwnProperty("betType"))
                object.betType = message.betType;
            if (message.autoFollowDouble != null && message.hasOwnProperty("autoFollowDouble"))
                object.autoFollowDouble = message.autoFollowDouble;
            if (message.autoFollowRight != null && message.hasOwnProperty("autoFollowRight"))
                object.autoFollowRight = message.autoFollowRight;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
            return object;
        };

        /**
         * Converts this BetReq to JSON.
         * @function toJSON
         * @memberof BlackJack.BetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetReq;
    })();

    BlackJack.BetRsp = (function() {

        /**
         * Properties of a BetRsp.
         * @memberof BlackJack
         * @interface IBetRsp
         * @property {number} errNo BetRsp errNo
         * @property {number|null} [coinBalance] BetRsp coinBalance
         * @property {number|null} [base] BetRsp base
         * @property {number|null} [pair] BetRsp pair
         * @property {number|null} [b21p3] BetRsp b21p3
         * @property {number|null} [pos] BetRsp pos
         */

        /**
         * Constructs a new BetRsp.
         * @memberof BlackJack
         * @classdesc Represents a BetRsp.
         * @implements IBetRsp
         * @constructor
         * @param {BlackJack.IBetRsp=} [properties] Properties to set
         */
        function BetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.errNo = 0;

        /**
         * BetRsp coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.coinBalance = 0;

        /**
         * BetRsp base.
         * @member {number} base
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.base = 0;

        /**
         * BetRsp pair.
         * @member {number} pair
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.pair = 0;

        /**
         * BetRsp b21p3.
         * @member {number} b21p3
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.b21p3 = 0;

        /**
         * BetRsp pos.
         * @member {number} pos
         * @memberof BlackJack.BetRsp
         * @instance
         */
        BetRsp.prototype.pos = 0;

        /**
         * Creates a new BetRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetRsp
         * @static
         * @param {BlackJack.IBetRsp=} [properties] Properties to set
         * @returns {BlackJack.BetRsp} BetRsp instance
         */
        BetRsp.create = function create(properties) {
            return new BetRsp(properties);
        };

        /**
         * Encodes the specified BetRsp message. Does not implicitly {@link BlackJack.BetRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetRsp
         * @static
         * @param {BlackJack.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.coinBalance);
            if (message.base != null && message.hasOwnProperty("base"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.base);
            if (message.pair != null && message.hasOwnProperty("pair"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.pair);
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.b21p3);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified BetRsp message, length delimited. Does not implicitly {@link BlackJack.BetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetRsp
         * @static
         * @param {BlackJack.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 2:
                    message.coinBalance = reader.double();
                    break;
                case 3:
                    message.base = reader.double();
                    break;
                case 4:
                    message.pair = reader.double();
                    break;
                case 5:
                    message.b21p3 = reader.double();
                    break;
                case 8:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errNo"))
                throw $util.ProtocolError("missing required 'errNo'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetRsp message.
         * @function verify
         * @memberof BlackJack.BetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errNo))
                return "errNo: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.base != null && message.hasOwnProperty("base"))
                if (typeof message.base !== "number")
                    return "base: number expected";
            if (message.pair != null && message.hasOwnProperty("pair"))
                if (typeof message.pair !== "number")
                    return "pair: number expected";
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                if (typeof message.b21p3 !== "number")
                    return "b21p3: number expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a BetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetRsp} BetRsp
         */
        BetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetRsp)
                return object;
            var message = new $root.BlackJack.BetRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.base != null)
                message.base = Number(object.base);
            if (object.pair != null)
                message.pair = Number(object.pair);
            if (object.b21p3 != null)
                message.b21p3 = Number(object.b21p3);
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetRsp
         * @static
         * @param {BlackJack.BetRsp} message BetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.coinBalance = 0;
                object.base = 0;
                object.pair = 0;
                object.b21p3 = 0;
                object.pos = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            if (message.base != null && message.hasOwnProperty("base"))
                object.base = options.json && !isFinite(message.base) ? String(message.base) : message.base;
            if (message.pair != null && message.hasOwnProperty("pair"))
                object.pair = options.json && !isFinite(message.pair) ? String(message.pair) : message.pair;
            if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                object.b21p3 = options.json && !isFinite(message.b21p3) ? String(message.b21p3) : message.b21p3;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this BetRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.BetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetRsp;
    })();

    BlackJack.BetNotify = (function() {

        /**
         * Properties of a BetNotify.
         * @memberof BlackJack
         * @interface IBetNotify
         * @property {number|null} [pos] BetNotify pos
         * @property {number|null} [playerId] BetNotify playerId
         * @property {number|null} [coinBalance] BetNotify coinBalance
         * @property {number|null} [bet] BetNotify bet
         * @property {number|null} [betType] BetNotify betType
         */

        /**
         * Constructs a new BetNotify.
         * @memberof BlackJack
         * @classdesc Represents a BetNotify.
         * @implements IBetNotify
         * @constructor
         * @param {BlackJack.IBetNotify=} [properties] Properties to set
         */
        function BetNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetNotify pos.
         * @member {number} pos
         * @memberof BlackJack.BetNotify
         * @instance
         */
        BetNotify.prototype.pos = 0;

        /**
         * BetNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.BetNotify
         * @instance
         */
        BetNotify.prototype.playerId = 0;

        /**
         * BetNotify coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.BetNotify
         * @instance
         */
        BetNotify.prototype.coinBalance = 0;

        /**
         * BetNotify bet.
         * @member {number} bet
         * @memberof BlackJack.BetNotify
         * @instance
         */
        BetNotify.prototype.bet = 0;

        /**
         * BetNotify betType.
         * @member {number} betType
         * @memberof BlackJack.BetNotify
         * @instance
         */
        BetNotify.prototype.betType = 0;

        /**
         * Creates a new BetNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetNotify
         * @static
         * @param {BlackJack.IBetNotify=} [properties] Properties to set
         * @returns {BlackJack.BetNotify} BetNotify instance
         */
        BetNotify.create = function create(properties) {
            return new BetNotify(properties);
        };

        /**
         * Encodes the specified BetNotify message. Does not implicitly {@link BlackJack.BetNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetNotify
         * @static
         * @param {BlackJack.IBetNotify} message BetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.coinBalance);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.betType != null && message.hasOwnProperty("betType"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.betType);
            if (message.bet != null && message.hasOwnProperty("bet"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.bet);
            return writer;
        };

        /**
         * Encodes the specified BetNotify message, length delimited. Does not implicitly {@link BlackJack.BetNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetNotify
         * @static
         * @param {BlackJack.IBetNotify} message BetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetNotify} BetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.coinBalance = reader.double();
                    break;
                case 5:
                    message.bet = reader.double();
                    break;
                case 4:
                    message.betType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetNotify} BetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetNotify message.
         * @function verify
         * @memberof BlackJack.BetNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.bet != null && message.hasOwnProperty("bet"))
                if (typeof message.bet !== "number")
                    return "bet: number expected";
            if (message.betType != null && message.hasOwnProperty("betType"))
                if (!$util.isInteger(message.betType))
                    return "betType: integer expected";
            return null;
        };

        /**
         * Creates a BetNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetNotify} BetNotify
         */
        BetNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetNotify)
                return object;
            var message = new $root.BlackJack.BetNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.bet != null)
                message.bet = Number(object.bet);
            if (object.betType != null)
                message.betType = object.betType | 0;
            return message;
        };

        /**
         * Creates a plain object from a BetNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetNotify
         * @static
         * @param {BlackJack.BetNotify} message BetNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.coinBalance = 0;
                object.playerId = 0;
                object.betType = 0;
                object.bet = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.betType != null && message.hasOwnProperty("betType"))
                object.betType = message.betType;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
            return object;
        };

        /**
         * Converts this BetNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.BetNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetNotify;
    })();

    BlackJack.OccupySeatReq = (function() {

        /**
         * Properties of an OccupySeatReq.
         * @memberof BlackJack
         * @interface IOccupySeatReq
         * @property {number|null} [pos] OccupySeatReq pos
         */

        /**
         * Constructs a new OccupySeatReq.
         * @memberof BlackJack
         * @classdesc Represents an OccupySeatReq.
         * @implements IOccupySeatReq
         * @constructor
         * @param {BlackJack.IOccupySeatReq=} [properties] Properties to set
         */
        function OccupySeatReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupySeatReq pos.
         * @member {number} pos
         * @memberof BlackJack.OccupySeatReq
         * @instance
         */
        OccupySeatReq.prototype.pos = 0;

        /**
         * Creates a new OccupySeatReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {BlackJack.IOccupySeatReq=} [properties] Properties to set
         * @returns {BlackJack.OccupySeatReq} OccupySeatReq instance
         */
        OccupySeatReq.create = function create(properties) {
            return new OccupySeatReq(properties);
        };

        /**
         * Encodes the specified OccupySeatReq message. Does not implicitly {@link BlackJack.OccupySeatReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {BlackJack.IOccupySeatReq} message OccupySeatReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified OccupySeatReq message, length delimited. Does not implicitly {@link BlackJack.OccupySeatReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {BlackJack.IOccupySeatReq} message OccupySeatReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupySeatReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.OccupySeatReq} OccupySeatReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.OccupySeatReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupySeatReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.OccupySeatReq} OccupySeatReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupySeatReq message.
         * @function verify
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupySeatReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates an OccupySeatReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.OccupySeatReq} OccupySeatReq
         */
        OccupySeatReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.OccupySeatReq)
                return object;
            var message = new $root.BlackJack.OccupySeatReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an OccupySeatReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.OccupySeatReq
         * @static
         * @param {BlackJack.OccupySeatReq} message OccupySeatReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupySeatReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pos = 0;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this OccupySeatReq to JSON.
         * @function toJSON
         * @memberof BlackJack.OccupySeatReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupySeatReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupySeatReq;
    })();

    BlackJack.OccupySeatRsp = (function() {

        /**
         * Properties of an OccupySeatRsp.
         * @memberof BlackJack
         * @interface IOccupySeatRsp
         * @property {number|null} [errNo] OccupySeatRsp errNo
         */

        /**
         * Constructs a new OccupySeatRsp.
         * @memberof BlackJack
         * @classdesc Represents an OccupySeatRsp.
         * @implements IOccupySeatRsp
         * @constructor
         * @param {BlackJack.IOccupySeatRsp=} [properties] Properties to set
         */
        function OccupySeatRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupySeatRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.OccupySeatRsp
         * @instance
         */
        OccupySeatRsp.prototype.errNo = 0;

        /**
         * Creates a new OccupySeatRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {BlackJack.IOccupySeatRsp=} [properties] Properties to set
         * @returns {BlackJack.OccupySeatRsp} OccupySeatRsp instance
         */
        OccupySeatRsp.create = function create(properties) {
            return new OccupySeatRsp(properties);
        };

        /**
         * Encodes the specified OccupySeatRsp message. Does not implicitly {@link BlackJack.OccupySeatRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {BlackJack.IOccupySeatRsp} message OccupySeatRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified OccupySeatRsp message, length delimited. Does not implicitly {@link BlackJack.OccupySeatRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {BlackJack.IOccupySeatRsp} message OccupySeatRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupySeatRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.OccupySeatRsp} OccupySeatRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.OccupySeatRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupySeatRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.OccupySeatRsp} OccupySeatRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupySeatRsp message.
         * @function verify
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupySeatRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates an OccupySeatRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.OccupySeatRsp} OccupySeatRsp
         */
        OccupySeatRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.OccupySeatRsp)
                return object;
            var message = new $root.BlackJack.OccupySeatRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from an OccupySeatRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.OccupySeatRsp
         * @static
         * @param {BlackJack.OccupySeatRsp} message OccupySeatRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupySeatRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this OccupySeatRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.OccupySeatRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupySeatRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupySeatRsp;
    })();

    BlackJack.OccupySeatNotify = (function() {

        /**
         * Properties of an OccupySeatNotify.
         * @memberof BlackJack
         * @interface IOccupySeatNotify
         * @property {number|null} [pos] OccupySeatNotify pos
         * @property {number|null} [playerId] OccupySeatNotify playerId
         * @property {number|null} [coinBalance] OccupySeatNotify coinBalance
         * @property {string|null} [userJson] OccupySeatNotify userJson
         */

        /**
         * Constructs a new OccupySeatNotify.
         * @memberof BlackJack
         * @classdesc Represents an OccupySeatNotify.
         * @implements IOccupySeatNotify
         * @constructor
         * @param {BlackJack.IOccupySeatNotify=} [properties] Properties to set
         */
        function OccupySeatNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OccupySeatNotify pos.
         * @member {number} pos
         * @memberof BlackJack.OccupySeatNotify
         * @instance
         */
        OccupySeatNotify.prototype.pos = 0;

        /**
         * OccupySeatNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.OccupySeatNotify
         * @instance
         */
        OccupySeatNotify.prototype.playerId = 0;

        /**
         * OccupySeatNotify coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.OccupySeatNotify
         * @instance
         */
        OccupySeatNotify.prototype.coinBalance = 0;

        /**
         * OccupySeatNotify userJson.
         * @member {string} userJson
         * @memberof BlackJack.OccupySeatNotify
         * @instance
         */
        OccupySeatNotify.prototype.userJson = "";

        /**
         * Creates a new OccupySeatNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {BlackJack.IOccupySeatNotify=} [properties] Properties to set
         * @returns {BlackJack.OccupySeatNotify} OccupySeatNotify instance
         */
        OccupySeatNotify.create = function create(properties) {
            return new OccupySeatNotify(properties);
        };

        /**
         * Encodes the specified OccupySeatNotify message. Does not implicitly {@link BlackJack.OccupySeatNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {BlackJack.IOccupySeatNotify} message OccupySeatNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerId);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.coinBalance);
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.userJson);
            return writer;
        };

        /**
         * Encodes the specified OccupySeatNotify message, length delimited. Does not implicitly {@link BlackJack.OccupySeatNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {BlackJack.IOccupySeatNotify} message OccupySeatNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OccupySeatNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OccupySeatNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.OccupySeatNotify} OccupySeatNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.OccupySeatNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.playerId = reader.int32();
                    break;
                case 3:
                    message.coinBalance = reader.double();
                    break;
                case 13:
                    message.userJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OccupySeatNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.OccupySeatNotify} OccupySeatNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OccupySeatNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OccupySeatNotify message.
         * @function verify
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OccupySeatNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                if (!$util.isString(message.userJson))
                    return "userJson: string expected";
            return null;
        };

        /**
         * Creates an OccupySeatNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.OccupySeatNotify} OccupySeatNotify
         */
        OccupySeatNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.OccupySeatNotify)
                return object;
            var message = new $root.BlackJack.OccupySeatNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            if (object.userJson != null)
                message.userJson = String(object.userJson);
            return message;
        };

        /**
         * Creates a plain object from an OccupySeatNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.OccupySeatNotify
         * @static
         * @param {BlackJack.OccupySeatNotify} message OccupySeatNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OccupySeatNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.playerId = 0;
                object.coinBalance = 0;
                object.userJson = "";
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                object.userJson = message.userJson;
            return object;
        };

        /**
         * Converts this OccupySeatNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.OccupySeatNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OccupySeatNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OccupySeatNotify;
    })();

    BlackJack.DealCardNotify = (function() {

        /**
         * Properties of a DealCardNotify.
         * @memberof BlackJack
         * @interface IDealCardNotify
         * @property {Array.<BlackJack.DealCardNotify.IPosInfo>|null} [posInfo] DealCardNotify posInfo
         * @property {Array.<number>|null} [bankerCards] DealCardNotify bankerCards
         * @property {number|null} [bankerCardPoint] DealCardNotify bankerCardPoint
         * @property {number|null} [dealCnt] DealCardNotify dealCnt
         * @property {string|null} [roundSign] DealCardNotify roundSign
         */

        /**
         * Constructs a new DealCardNotify.
         * @memberof BlackJack
         * @classdesc Represents a DealCardNotify.
         * @implements IDealCardNotify
         * @constructor
         * @param {BlackJack.IDealCardNotify=} [properties] Properties to set
         */
        function DealCardNotify(properties) {
            this.posInfo = [];
            this.bankerCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DealCardNotify posInfo.
         * @member {Array.<BlackJack.DealCardNotify.IPosInfo>} posInfo
         * @memberof BlackJack.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.posInfo = $util.emptyArray;

        /**
         * DealCardNotify bankerCards.
         * @member {Array.<number>} bankerCards
         * @memberof BlackJack.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.bankerCards = $util.emptyArray;

        /**
         * DealCardNotify bankerCardPoint.
         * @member {number} bankerCardPoint
         * @memberof BlackJack.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.bankerCardPoint = 0;

        /**
         * DealCardNotify dealCnt.
         * @member {number} dealCnt
         * @memberof BlackJack.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.dealCnt = 0;

        /**
         * DealCardNotify roundSign.
         * @member {string} roundSign
         * @memberof BlackJack.DealCardNotify
         * @instance
         */
        DealCardNotify.prototype.roundSign = "";

        /**
         * Creates a new DealCardNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {BlackJack.IDealCardNotify=} [properties] Properties to set
         * @returns {BlackJack.DealCardNotify} DealCardNotify instance
         */
        DealCardNotify.create = function create(properties) {
            return new DealCardNotify(properties);
        };

        /**
         * Encodes the specified DealCardNotify message. Does not implicitly {@link BlackJack.DealCardNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {BlackJack.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.posInfo != null && message.posInfo.length)
                for (var i = 0; i < message.posInfo.length; ++i)
                    $root.BlackJack.DealCardNotify.PosInfo.encode(message.posInfo[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.bankerCards != null && message.bankerCards.length)
                for (var i = 0; i < message.bankerCards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.bankerCards[i]);
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bankerCardPoint);
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dealCnt);
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.roundSign);
            return writer;
        };

        /**
         * Encodes the specified DealCardNotify message, length delimited. Does not implicitly {@link BlackJack.DealCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {BlackJack.IDealCardNotify} message DealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DealCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.posInfo && message.posInfo.length))
                        message.posInfo = [];
                    message.posInfo.push($root.BlackJack.DealCardNotify.PosInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.bankerCards && message.bankerCards.length))
                        message.bankerCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.bankerCards.push(reader.int32());
                    } else
                        message.bankerCards.push(reader.int32());
                    break;
                case 3:
                    message.bankerCardPoint = reader.int32();
                    break;
                case 4:
                    message.dealCnt = reader.int32();
                    break;
                case 15:
                    message.roundSign = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DealCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.DealCardNotify} DealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DealCardNotify message.
         * @function verify
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DealCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                if (!Array.isArray(message.posInfo))
                    return "posInfo: array expected";
                for (var i = 0; i < message.posInfo.length; ++i) {
                    var error = $root.BlackJack.DealCardNotify.PosInfo.verify(message.posInfo[i]);
                    if (error)
                        return "posInfo." + error;
                }
            }
            if (message.bankerCards != null && message.hasOwnProperty("bankerCards")) {
                if (!Array.isArray(message.bankerCards))
                    return "bankerCards: array expected";
                for (var i = 0; i < message.bankerCards.length; ++i)
                    if (!$util.isInteger(message.bankerCards[i]))
                        return "bankerCards: integer[] expected";
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                if (!$util.isInteger(message.bankerCardPoint))
                    return "bankerCardPoint: integer expected";
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                if (!$util.isInteger(message.dealCnt))
                    return "dealCnt: integer expected";
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                if (!$util.isString(message.roundSign))
                    return "roundSign: string expected";
            return null;
        };

        /**
         * Creates a DealCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.DealCardNotify} DealCardNotify
         */
        DealCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.DealCardNotify)
                return object;
            var message = new $root.BlackJack.DealCardNotify();
            if (object.posInfo) {
                if (!Array.isArray(object.posInfo))
                    throw TypeError(".BlackJack.DealCardNotify.posInfo: array expected");
                message.posInfo = [];
                for (var i = 0; i < object.posInfo.length; ++i) {
                    if (typeof object.posInfo[i] !== "object")
                        throw TypeError(".BlackJack.DealCardNotify.posInfo: object expected");
                    message.posInfo[i] = $root.BlackJack.DealCardNotify.PosInfo.fromObject(object.posInfo[i]);
                }
            }
            if (object.bankerCards) {
                if (!Array.isArray(object.bankerCards))
                    throw TypeError(".BlackJack.DealCardNotify.bankerCards: array expected");
                message.bankerCards = [];
                for (var i = 0; i < object.bankerCards.length; ++i)
                    message.bankerCards[i] = object.bankerCards[i] | 0;
            }
            if (object.bankerCardPoint != null)
                message.bankerCardPoint = object.bankerCardPoint | 0;
            if (object.dealCnt != null)
                message.dealCnt = object.dealCnt | 0;
            if (object.roundSign != null)
                message.roundSign = String(object.roundSign);
            return message;
        };

        /**
         * Creates a plain object from a DealCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.DealCardNotify
         * @static
         * @param {BlackJack.DealCardNotify} message DealCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DealCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.posInfo = [];
                object.bankerCards = [];
            }
            if (options.defaults) {
                object.bankerCardPoint = 0;
                object.dealCnt = 0;
                object.roundSign = "";
            }
            if (message.posInfo && message.posInfo.length) {
                object.posInfo = [];
                for (var j = 0; j < message.posInfo.length; ++j)
                    object.posInfo[j] = $root.BlackJack.DealCardNotify.PosInfo.toObject(message.posInfo[j], options);
            }
            if (message.bankerCards && message.bankerCards.length) {
                object.bankerCards = [];
                for (var j = 0; j < message.bankerCards.length; ++j)
                    object.bankerCards[j] = message.bankerCards[j];
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                object.bankerCardPoint = message.bankerCardPoint;
            if (message.dealCnt != null && message.hasOwnProperty("dealCnt"))
                object.dealCnt = message.dealCnt;
            if (message.roundSign != null && message.hasOwnProperty("roundSign"))
                object.roundSign = message.roundSign;
            return object;
        };

        /**
         * Converts this DealCardNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.DealCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DealCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DealCardNotify.PosInfo = (function() {

            /**
             * Properties of a PosInfo.
             * @memberof BlackJack.DealCardNotify
             * @interface IPosInfo
             * @property {number|null} [pos] PosInfo pos
             * @property {number|null} [playerId] PosInfo playerId
             * @property {BlackJack.ICardInfo|null} [cardInfo] PosInfo cardInfo
             */

            /**
             * Constructs a new PosInfo.
             * @memberof BlackJack.DealCardNotify
             * @classdesc Represents a PosInfo.
             * @implements IPosInfo
             * @constructor
             * @param {BlackJack.DealCardNotify.IPosInfo=} [properties] Properties to set
             */
            function PosInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PosInfo pos.
             * @member {number} pos
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @instance
             */
            PosInfo.prototype.pos = 0;

            /**
             * PosInfo playerId.
             * @member {number} playerId
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @instance
             */
            PosInfo.prototype.playerId = 0;

            /**
             * PosInfo cardInfo.
             * @member {BlackJack.ICardInfo|null|undefined} cardInfo
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @instance
             */
            PosInfo.prototype.cardInfo = null;

            /**
             * Creates a new PosInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {BlackJack.DealCardNotify.IPosInfo=} [properties] Properties to set
             * @returns {BlackJack.DealCardNotify.PosInfo} PosInfo instance
             */
            PosInfo.create = function create(properties) {
                return new PosInfo(properties);
            };

            /**
             * Encodes the specified PosInfo message. Does not implicitly {@link BlackJack.DealCardNotify.PosInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {BlackJack.DealCardNotify.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
                if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                    $root.BlackJack.CardInfo.encode(message.cardInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
                return writer;
            };

            /**
             * Encodes the specified PosInfo message, length delimited. Does not implicitly {@link BlackJack.DealCardNotify.PosInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {BlackJack.DealCardNotify.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.DealCardNotify.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DealCardNotify.PosInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.uint32();
                        break;
                    case 3:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.cardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.DealCardNotify.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PosInfo message.
             * @function verify
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PosInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.cardInfo != null && message.hasOwnProperty("cardInfo")) {
                    var error = $root.BlackJack.CardInfo.verify(message.cardInfo);
                    if (error)
                        return "cardInfo." + error;
                }
                return null;
            };

            /**
             * Creates a PosInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.DealCardNotify.PosInfo} PosInfo
             */
            PosInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.DealCardNotify.PosInfo)
                    return object;
                var message = new $root.BlackJack.DealCardNotify.PosInfo();
                if (object.pos != null)
                    message.pos = object.pos >>> 0;
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.cardInfo != null) {
                    if (typeof object.cardInfo !== "object")
                        throw TypeError(".BlackJack.DealCardNotify.PosInfo.cardInfo: object expected");
                    message.cardInfo = $root.BlackJack.CardInfo.fromObject(object.cardInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a PosInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @static
             * @param {BlackJack.DealCardNotify.PosInfo} message PosInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PosInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.pos = 0;
                    object.cardInfo = null;
                    object.playerId = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                    object.cardInfo = $root.BlackJack.CardInfo.toObject(message.cardInfo, options);
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                return object;
            };

            /**
             * Converts this PosInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.DealCardNotify.PosInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PosInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PosInfo;
        })();

        return DealCardNotify;
    })();

    BlackJack.BankerDealCardNotify = (function() {

        /**
         * Properties of a BankerDealCardNotify.
         * @memberof BlackJack
         * @interface IBankerDealCardNotify
         * @property {Array.<number>|null} [cards] BankerDealCardNotify cards
         * @property {number|null} [cardPoint] BankerDealCardNotify cardPoint
         * @property {number|null} [status] BankerDealCardNotify status
         */

        /**
         * Constructs a new BankerDealCardNotify.
         * @memberof BlackJack
         * @classdesc Represents a BankerDealCardNotify.
         * @implements IBankerDealCardNotify
         * @constructor
         * @param {BlackJack.IBankerDealCardNotify=} [properties] Properties to set
         */
        function BankerDealCardNotify(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerDealCardNotify cards.
         * @member {Array.<number>} cards
         * @memberof BlackJack.BankerDealCardNotify
         * @instance
         */
        BankerDealCardNotify.prototype.cards = $util.emptyArray;

        /**
         * BankerDealCardNotify cardPoint.
         * @member {number} cardPoint
         * @memberof BlackJack.BankerDealCardNotify
         * @instance
         */
        BankerDealCardNotify.prototype.cardPoint = 0;

        /**
         * BankerDealCardNotify status.
         * @member {number} status
         * @memberof BlackJack.BankerDealCardNotify
         * @instance
         */
        BankerDealCardNotify.prototype.status = 0;

        /**
         * Creates a new BankerDealCardNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {BlackJack.IBankerDealCardNotify=} [properties] Properties to set
         * @returns {BlackJack.BankerDealCardNotify} BankerDealCardNotify instance
         */
        BankerDealCardNotify.create = function create(properties) {
            return new BankerDealCardNotify(properties);
        };

        /**
         * Encodes the specified BankerDealCardNotify message. Does not implicitly {@link BlackJack.BankerDealCardNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {BlackJack.IBankerDealCardNotify} message BankerDealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerDealCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cards[i]);
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cardPoint);
            if (message.status != null && message.hasOwnProperty("status"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified BankerDealCardNotify message, length delimited. Does not implicitly {@link BlackJack.BankerDealCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {BlackJack.IBankerDealCardNotify} message BankerDealCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerDealCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerDealCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BankerDealCardNotify} BankerDealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerDealCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BankerDealCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 2:
                    message.cardPoint = reader.int32();
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BankerDealCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BankerDealCardNotify} BankerDealCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerDealCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerDealCardNotify message.
         * @function verify
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerDealCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                if (!$util.isInteger(message.cardPoint))
                    return "cardPoint: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            return null;
        };

        /**
         * Creates a BankerDealCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BankerDealCardNotify} BankerDealCardNotify
         */
        BankerDealCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BankerDealCardNotify)
                return object;
            var message = new $root.BlackJack.BankerDealCardNotify();
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".BlackJack.BankerDealCardNotify.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.cardPoint != null)
                message.cardPoint = object.cardPoint | 0;
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from a BankerDealCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BankerDealCardNotify
         * @static
         * @param {BlackJack.BankerDealCardNotify} message BankerDealCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerDealCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (options.defaults) {
                object.cardPoint = 0;
                object.status = 0;
            }
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.cardPoint != null && message.hasOwnProperty("cardPoint"))
                object.cardPoint = message.cardPoint;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this BankerDealCardNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.BankerDealCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerDealCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerDealCardNotify;
    })();

    BlackJack.DoubleBetReq = (function() {

        /**
         * Properties of a DoubleBetReq.
         * @memberof BlackJack
         * @interface IDoubleBetReq
         * @property {number|null} [pos] DoubleBetReq pos
         */

        /**
         * Constructs a new DoubleBetReq.
         * @memberof BlackJack
         * @classdesc Represents a DoubleBetReq.
         * @implements IDoubleBetReq
         * @constructor
         * @param {BlackJack.IDoubleBetReq=} [properties] Properties to set
         */
        function DoubleBetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DoubleBetReq pos.
         * @member {number} pos
         * @memberof BlackJack.DoubleBetReq
         * @instance
         */
        DoubleBetReq.prototype.pos = 0;

        /**
         * Creates a new DoubleBetReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {BlackJack.IDoubleBetReq=} [properties] Properties to set
         * @returns {BlackJack.DoubleBetReq} DoubleBetReq instance
         */
        DoubleBetReq.create = function create(properties) {
            return new DoubleBetReq(properties);
        };

        /**
         * Encodes the specified DoubleBetReq message. Does not implicitly {@link BlackJack.DoubleBetReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {BlackJack.IDoubleBetReq} message DoubleBetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified DoubleBetReq message, length delimited. Does not implicitly {@link BlackJack.DoubleBetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {BlackJack.IDoubleBetReq} message DoubleBetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DoubleBetReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.DoubleBetReq} DoubleBetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DoubleBetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DoubleBetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.DoubleBetReq} DoubleBetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DoubleBetReq message.
         * @function verify
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DoubleBetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a DoubleBetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.DoubleBetReq} DoubleBetReq
         */
        DoubleBetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.DoubleBetReq)
                return object;
            var message = new $root.BlackJack.DoubleBetReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a DoubleBetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.DoubleBetReq
         * @static
         * @param {BlackJack.DoubleBetReq} message DoubleBetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DoubleBetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pos = 0;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this DoubleBetReq to JSON.
         * @function toJSON
         * @memberof BlackJack.DoubleBetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DoubleBetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DoubleBetReq;
    })();

    BlackJack.DoubleBetRsp = (function() {

        /**
         * Properties of a DoubleBetRsp.
         * @memberof BlackJack
         * @interface IDoubleBetRsp
         * @property {number} errNo DoubleBetRsp errNo
         * @property {number|null} [pos] DoubleBetRsp pos
         */

        /**
         * Constructs a new DoubleBetRsp.
         * @memberof BlackJack
         * @classdesc Represents a DoubleBetRsp.
         * @implements IDoubleBetRsp
         * @constructor
         * @param {BlackJack.IDoubleBetRsp=} [properties] Properties to set
         */
        function DoubleBetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DoubleBetRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.DoubleBetRsp
         * @instance
         */
        DoubleBetRsp.prototype.errNo = 0;

        /**
         * DoubleBetRsp pos.
         * @member {number} pos
         * @memberof BlackJack.DoubleBetRsp
         * @instance
         */
        DoubleBetRsp.prototype.pos = 0;

        /**
         * Creates a new DoubleBetRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {BlackJack.IDoubleBetRsp=} [properties] Properties to set
         * @returns {BlackJack.DoubleBetRsp} DoubleBetRsp instance
         */
        DoubleBetRsp.create = function create(properties) {
            return new DoubleBetRsp(properties);
        };

        /**
         * Encodes the specified DoubleBetRsp message. Does not implicitly {@link BlackJack.DoubleBetRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {BlackJack.IDoubleBetRsp} message DoubleBetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified DoubleBetRsp message, length delimited. Does not implicitly {@link BlackJack.DoubleBetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {BlackJack.IDoubleBetRsp} message DoubleBetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DoubleBetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.DoubleBetRsp} DoubleBetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DoubleBetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 8:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errNo"))
                throw $util.ProtocolError("missing required 'errNo'", { instance: message });
            return message;
        };

        /**
         * Decodes a DoubleBetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.DoubleBetRsp} DoubleBetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DoubleBetRsp message.
         * @function verify
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DoubleBetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errNo))
                return "errNo: integer expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a DoubleBetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.DoubleBetRsp} DoubleBetRsp
         */
        DoubleBetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.DoubleBetRsp)
                return object;
            var message = new $root.BlackJack.DoubleBetRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a DoubleBetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.DoubleBetRsp
         * @static
         * @param {BlackJack.DoubleBetRsp} message DoubleBetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DoubleBetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.pos = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this DoubleBetRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.DoubleBetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DoubleBetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DoubleBetRsp;
    })();

    BlackJack.DoubleBetNotify = (function() {

        /**
         * Properties of a DoubleBetNotify.
         * @memberof BlackJack
         * @interface IDoubleBetNotify
         * @property {number|null} [pos] DoubleBetNotify pos
         * @property {number|null} [playerId] DoubleBetNotify playerId
         * @property {BlackJack.ICardInfo|null} [cardInfo] DoubleBetNotify cardInfo
         * @property {Array.<BlackJack.DoubleBetNotify.IBetInfo>|null} [betInfo] DoubleBetNotify betInfo
         * @property {number|null} [nextPos] DoubleBetNotify nextPos
         */

        /**
         * Constructs a new DoubleBetNotify.
         * @memberof BlackJack
         * @classdesc Represents a DoubleBetNotify.
         * @implements IDoubleBetNotify
         * @constructor
         * @param {BlackJack.IDoubleBetNotify=} [properties] Properties to set
         */
        function DoubleBetNotify(properties) {
            this.betInfo = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DoubleBetNotify pos.
         * @member {number} pos
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         */
        DoubleBetNotify.prototype.pos = 0;

        /**
         * DoubleBetNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         */
        DoubleBetNotify.prototype.playerId = 0;

        /**
         * DoubleBetNotify cardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} cardInfo
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         */
        DoubleBetNotify.prototype.cardInfo = null;

        /**
         * DoubleBetNotify betInfo.
         * @member {Array.<BlackJack.DoubleBetNotify.IBetInfo>} betInfo
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         */
        DoubleBetNotify.prototype.betInfo = $util.emptyArray;

        /**
         * DoubleBetNotify nextPos.
         * @member {number} nextPos
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         */
        DoubleBetNotify.prototype.nextPos = 0;

        /**
         * Creates a new DoubleBetNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {BlackJack.IDoubleBetNotify=} [properties] Properties to set
         * @returns {BlackJack.DoubleBetNotify} DoubleBetNotify instance
         */
        DoubleBetNotify.create = function create(properties) {
            return new DoubleBetNotify(properties);
        };

        /**
         * Encodes the specified DoubleBetNotify message. Does not implicitly {@link BlackJack.DoubleBetNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {BlackJack.IDoubleBetNotify} message DoubleBetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                $root.BlackJack.CardInfo.encode(message.cardInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.nextPos);
            if (message.betInfo != null && message.betInfo.length)
                for (var i = 0; i < message.betInfo.length; ++i)
                    $root.BlackJack.DoubleBetNotify.BetInfo.encode(message.betInfo[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DoubleBetNotify message, length delimited. Does not implicitly {@link BlackJack.DoubleBetNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {BlackJack.IDoubleBetNotify} message DoubleBetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DoubleBetNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DoubleBetNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.DoubleBetNotify} DoubleBetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DoubleBetNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.cardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.betInfo && message.betInfo.length))
                        message.betInfo = [];
                    message.betInfo.push($root.BlackJack.DoubleBetNotify.BetInfo.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.nextPos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DoubleBetNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.DoubleBetNotify} DoubleBetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DoubleBetNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DoubleBetNotify message.
         * @function verify
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DoubleBetNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.cardInfo);
                if (error)
                    return "cardInfo." + error;
            }
            if (message.betInfo != null && message.hasOwnProperty("betInfo")) {
                if (!Array.isArray(message.betInfo))
                    return "betInfo: array expected";
                for (var i = 0; i < message.betInfo.length; ++i) {
                    var error = $root.BlackJack.DoubleBetNotify.BetInfo.verify(message.betInfo[i]);
                    if (error)
                        return "betInfo." + error;
                }
            }
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                if (!$util.isInteger(message.nextPos))
                    return "nextPos: integer expected";
            return null;
        };

        /**
         * Creates a DoubleBetNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.DoubleBetNotify} DoubleBetNotify
         */
        DoubleBetNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.DoubleBetNotify)
                return object;
            var message = new $root.BlackJack.DoubleBetNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.cardInfo != null) {
                if (typeof object.cardInfo !== "object")
                    throw TypeError(".BlackJack.DoubleBetNotify.cardInfo: object expected");
                message.cardInfo = $root.BlackJack.CardInfo.fromObject(object.cardInfo);
            }
            if (object.betInfo) {
                if (!Array.isArray(object.betInfo))
                    throw TypeError(".BlackJack.DoubleBetNotify.betInfo: array expected");
                message.betInfo = [];
                for (var i = 0; i < object.betInfo.length; ++i) {
                    if (typeof object.betInfo[i] !== "object")
                        throw TypeError(".BlackJack.DoubleBetNotify.betInfo: object expected");
                    message.betInfo[i] = $root.BlackJack.DoubleBetNotify.BetInfo.fromObject(object.betInfo[i]);
                }
            }
            if (object.nextPos != null)
                message.nextPos = object.nextPos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a DoubleBetNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.DoubleBetNotify
         * @static
         * @param {BlackJack.DoubleBetNotify} message DoubleBetNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DoubleBetNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.betInfo = [];
            if (options.defaults) {
                object.pos = 0;
                object.cardInfo = null;
                object.playerId = 0;
                object.nextPos = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                object.cardInfo = $root.BlackJack.CardInfo.toObject(message.cardInfo, options);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                object.nextPos = message.nextPos;
            if (message.betInfo && message.betInfo.length) {
                object.betInfo = [];
                for (var j = 0; j < message.betInfo.length; ++j)
                    object.betInfo[j] = $root.BlackJack.DoubleBetNotify.BetInfo.toObject(message.betInfo[j], options);
            }
            return object;
        };

        /**
         * Converts this DoubleBetNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.DoubleBetNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DoubleBetNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DoubleBetNotify.BetInfo = (function() {

            /**
             * Properties of a BetInfo.
             * @memberof BlackJack.DoubleBetNotify
             * @interface IBetInfo
             * @property {number|null} [bet] BetInfo bet
             * @property {number|null} [playerId] BetInfo playerId
             * @property {number|null} [coinBalance] BetInfo coinBalance
             */

            /**
             * Constructs a new BetInfo.
             * @memberof BlackJack.DoubleBetNotify
             * @classdesc Represents a BetInfo.
             * @implements IBetInfo
             * @constructor
             * @param {BlackJack.DoubleBetNotify.IBetInfo=} [properties] Properties to set
             */
            function BetInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetInfo bet.
             * @member {number} bet
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.bet = 0;

            /**
             * BetInfo playerId.
             * @member {number} playerId
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.playerId = 0;

            /**
             * BetInfo coinBalance.
             * @member {number} coinBalance
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.coinBalance = 0;

            /**
             * Creates a new BetInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {BlackJack.DoubleBetNotify.IBetInfo=} [properties] Properties to set
             * @returns {BlackJack.DoubleBetNotify.BetInfo} BetInfo instance
             */
            BetInfo.create = function create(properties) {
                return new BetInfo(properties);
            };

            /**
             * Encodes the specified BetInfo message. Does not implicitly {@link BlackJack.DoubleBetNotify.BetInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {BlackJack.DoubleBetNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.bet != null && message.hasOwnProperty("bet"))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.bet);
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerId);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.coinBalance);
                return writer;
            };

            /**
             * Encodes the specified BetInfo message, length delimited. Does not implicitly {@link BlackJack.DoubleBetNotify.BetInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {BlackJack.DoubleBetNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.DoubleBetNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.DoubleBetNotify.BetInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.bet = reader.double();
                        break;
                    case 2:
                        message.playerId = reader.int32();
                        break;
                    case 3:
                        message.coinBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.DoubleBetNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetInfo message.
             * @function verify
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.bet != null && message.hasOwnProperty("bet"))
                    if (typeof message.bet !== "number")
                        return "bet: number expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                return null;
            };

            /**
             * Creates a BetInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.DoubleBetNotify.BetInfo} BetInfo
             */
            BetInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.DoubleBetNotify.BetInfo)
                    return object;
                var message = new $root.BlackJack.DoubleBetNotify.BetInfo();
                if (object.bet != null)
                    message.bet = Number(object.bet);
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                return message;
            };

            /**
             * Creates a plain object from a BetInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @static
             * @param {BlackJack.DoubleBetNotify.BetInfo} message BetInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.bet = 0;
                    object.playerId = 0;
                    object.coinBalance = 0;
                }
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                return object;
            };

            /**
             * Converts this BetInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.DoubleBetNotify.BetInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BetInfo;
        })();

        return DoubleBetNotify;
    })();

    BlackJack.EnableRightReq = (function() {

        /**
         * Properties of an EnableRightReq.
         * @memberof BlackJack
         * @interface IEnableRightReq
         * @property {number|null} [pos] EnableRightReq pos
         */

        /**
         * Constructs a new EnableRightReq.
         * @memberof BlackJack
         * @classdesc Represents an EnableRightReq.
         * @implements IEnableRightReq
         * @constructor
         * @param {BlackJack.IEnableRightReq=} [properties] Properties to set
         */
        function EnableRightReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnableRightReq pos.
         * @member {number} pos
         * @memberof BlackJack.EnableRightReq
         * @instance
         */
        EnableRightReq.prototype.pos = 0;

        /**
         * Creates a new EnableRightReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {BlackJack.IEnableRightReq=} [properties] Properties to set
         * @returns {BlackJack.EnableRightReq} EnableRightReq instance
         */
        EnableRightReq.create = function create(properties) {
            return new EnableRightReq(properties);
        };

        /**
         * Encodes the specified EnableRightReq message. Does not implicitly {@link BlackJack.EnableRightReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {BlackJack.IEnableRightReq} message EnableRightReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified EnableRightReq message, length delimited. Does not implicitly {@link BlackJack.EnableRightReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {BlackJack.IEnableRightReq} message EnableRightReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnableRightReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.EnableRightReq} EnableRightReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.EnableRightReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnableRightReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.EnableRightReq} EnableRightReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnableRightReq message.
         * @function verify
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnableRightReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates an EnableRightReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.EnableRightReq} EnableRightReq
         */
        EnableRightReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.EnableRightReq)
                return object;
            var message = new $root.BlackJack.EnableRightReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an EnableRightReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.EnableRightReq
         * @static
         * @param {BlackJack.EnableRightReq} message EnableRightReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnableRightReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pos = 0;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this EnableRightReq to JSON.
         * @function toJSON
         * @memberof BlackJack.EnableRightReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnableRightReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnableRightReq;
    })();

    BlackJack.EnableRightRsp = (function() {

        /**
         * Properties of an EnableRightRsp.
         * @memberof BlackJack
         * @interface IEnableRightRsp
         * @property {number|null} [errNo] EnableRightRsp errNo
         * @property {number|null} [pos] EnableRightRsp pos
         */

        /**
         * Constructs a new EnableRightRsp.
         * @memberof BlackJack
         * @classdesc Represents an EnableRightRsp.
         * @implements IEnableRightRsp
         * @constructor
         * @param {BlackJack.IEnableRightRsp=} [properties] Properties to set
         */
        function EnableRightRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnableRightRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.EnableRightRsp
         * @instance
         */
        EnableRightRsp.prototype.errNo = 0;

        /**
         * EnableRightRsp pos.
         * @member {number} pos
         * @memberof BlackJack.EnableRightRsp
         * @instance
         */
        EnableRightRsp.prototype.pos = 0;

        /**
         * Creates a new EnableRightRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {BlackJack.IEnableRightRsp=} [properties] Properties to set
         * @returns {BlackJack.EnableRightRsp} EnableRightRsp instance
         */
        EnableRightRsp.create = function create(properties) {
            return new EnableRightRsp(properties);
        };

        /**
         * Encodes the specified EnableRightRsp message. Does not implicitly {@link BlackJack.EnableRightRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {BlackJack.IEnableRightRsp} message EnableRightRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified EnableRightRsp message, length delimited. Does not implicitly {@link BlackJack.EnableRightRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {BlackJack.IEnableRightRsp} message EnableRightRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnableRightRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.EnableRightRsp} EnableRightRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.EnableRightRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 8:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnableRightRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.EnableRightRsp} EnableRightRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnableRightRsp message.
         * @function verify
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnableRightRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates an EnableRightRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.EnableRightRsp} EnableRightRsp
         */
        EnableRightRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.EnableRightRsp)
                return object;
            var message = new $root.BlackJack.EnableRightRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an EnableRightRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.EnableRightRsp
         * @static
         * @param {BlackJack.EnableRightRsp} message EnableRightRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnableRightRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.pos = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this EnableRightRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.EnableRightRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnableRightRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnableRightRsp;
    })();

    BlackJack.EnableRightNotify = (function() {

        /**
         * Properties of an EnableRightNotify.
         * @memberof BlackJack
         * @interface IEnableRightNotify
         * @property {number|null} [pos] EnableRightNotify pos
         * @property {number|null} [playerId] EnableRightNotify playerId
         * @property {BlackJack.ICardInfo|null} [leftCardInfo] EnableRightNotify leftCardInfo
         * @property {BlackJack.ICardInfo|null} [rightCardInfo] EnableRightNotify rightCardInfo
         * @property {Array.<BlackJack.EnableRightNotify.IBetInfo>|null} [leftBetInfo] EnableRightNotify leftBetInfo
         * @property {Array.<BlackJack.EnableRightNotify.IBetInfo>|null} [rightBetInfo] EnableRightNotify rightBetInfo
         */

        /**
         * Constructs a new EnableRightNotify.
         * @memberof BlackJack
         * @classdesc Represents an EnableRightNotify.
         * @implements IEnableRightNotify
         * @constructor
         * @param {BlackJack.IEnableRightNotify=} [properties] Properties to set
         */
        function EnableRightNotify(properties) {
            this.leftBetInfo = [];
            this.rightBetInfo = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnableRightNotify pos.
         * @member {number} pos
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.pos = 0;

        /**
         * EnableRightNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.playerId = 0;

        /**
         * EnableRightNotify leftCardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} leftCardInfo
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.leftCardInfo = null;

        /**
         * EnableRightNotify rightCardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} rightCardInfo
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.rightCardInfo = null;

        /**
         * EnableRightNotify leftBetInfo.
         * @member {Array.<BlackJack.EnableRightNotify.IBetInfo>} leftBetInfo
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.leftBetInfo = $util.emptyArray;

        /**
         * EnableRightNotify rightBetInfo.
         * @member {Array.<BlackJack.EnableRightNotify.IBetInfo>} rightBetInfo
         * @memberof BlackJack.EnableRightNotify
         * @instance
         */
        EnableRightNotify.prototype.rightBetInfo = $util.emptyArray;

        /**
         * Creates a new EnableRightNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {BlackJack.IEnableRightNotify=} [properties] Properties to set
         * @returns {BlackJack.EnableRightNotify} EnableRightNotify instance
         */
        EnableRightNotify.create = function create(properties) {
            return new EnableRightNotify(properties);
        };

        /**
         * Encodes the specified EnableRightNotify message. Does not implicitly {@link BlackJack.EnableRightNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {BlackJack.IEnableRightNotify} message EnableRightNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerId);
            if (message.leftCardInfo != null && message.hasOwnProperty("leftCardInfo"))
                $root.BlackJack.CardInfo.encode(message.leftCardInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.rightCardInfo != null && message.hasOwnProperty("rightCardInfo"))
                $root.BlackJack.CardInfo.encode(message.rightCardInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.leftBetInfo != null && message.leftBetInfo.length)
                for (var i = 0; i < message.leftBetInfo.length; ++i)
                    $root.BlackJack.EnableRightNotify.BetInfo.encode(message.leftBetInfo[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.rightBetInfo != null && message.rightBetInfo.length)
                for (var i = 0; i < message.rightBetInfo.length; ++i)
                    $root.BlackJack.EnableRightNotify.BetInfo.encode(message.rightBetInfo[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified EnableRightNotify message, length delimited. Does not implicitly {@link BlackJack.EnableRightNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {BlackJack.IEnableRightNotify} message EnableRightNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnableRightNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnableRightNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.EnableRightNotify} EnableRightNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.EnableRightNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.playerId = reader.int32();
                    break;
                case 3:
                    message.leftCardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.rightCardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.leftBetInfo && message.leftBetInfo.length))
                        message.leftBetInfo = [];
                    message.leftBetInfo.push($root.BlackJack.EnableRightNotify.BetInfo.decode(reader, reader.uint32()));
                    break;
                case 6:
                    if (!(message.rightBetInfo && message.rightBetInfo.length))
                        message.rightBetInfo = [];
                    message.rightBetInfo.push($root.BlackJack.EnableRightNotify.BetInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnableRightNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.EnableRightNotify} EnableRightNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnableRightNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnableRightNotify message.
         * @function verify
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnableRightNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.leftCardInfo != null && message.hasOwnProperty("leftCardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.leftCardInfo);
                if (error)
                    return "leftCardInfo." + error;
            }
            if (message.rightCardInfo != null && message.hasOwnProperty("rightCardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.rightCardInfo);
                if (error)
                    return "rightCardInfo." + error;
            }
            if (message.leftBetInfo != null && message.hasOwnProperty("leftBetInfo")) {
                if (!Array.isArray(message.leftBetInfo))
                    return "leftBetInfo: array expected";
                for (var i = 0; i < message.leftBetInfo.length; ++i) {
                    var error = $root.BlackJack.EnableRightNotify.BetInfo.verify(message.leftBetInfo[i]);
                    if (error)
                        return "leftBetInfo." + error;
                }
            }
            if (message.rightBetInfo != null && message.hasOwnProperty("rightBetInfo")) {
                if (!Array.isArray(message.rightBetInfo))
                    return "rightBetInfo: array expected";
                for (var i = 0; i < message.rightBetInfo.length; ++i) {
                    var error = $root.BlackJack.EnableRightNotify.BetInfo.verify(message.rightBetInfo[i]);
                    if (error)
                        return "rightBetInfo." + error;
                }
            }
            return null;
        };

        /**
         * Creates an EnableRightNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.EnableRightNotify} EnableRightNotify
         */
        EnableRightNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.EnableRightNotify)
                return object;
            var message = new $root.BlackJack.EnableRightNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.leftCardInfo != null) {
                if (typeof object.leftCardInfo !== "object")
                    throw TypeError(".BlackJack.EnableRightNotify.leftCardInfo: object expected");
                message.leftCardInfo = $root.BlackJack.CardInfo.fromObject(object.leftCardInfo);
            }
            if (object.rightCardInfo != null) {
                if (typeof object.rightCardInfo !== "object")
                    throw TypeError(".BlackJack.EnableRightNotify.rightCardInfo: object expected");
                message.rightCardInfo = $root.BlackJack.CardInfo.fromObject(object.rightCardInfo);
            }
            if (object.leftBetInfo) {
                if (!Array.isArray(object.leftBetInfo))
                    throw TypeError(".BlackJack.EnableRightNotify.leftBetInfo: array expected");
                message.leftBetInfo = [];
                for (var i = 0; i < object.leftBetInfo.length; ++i) {
                    if (typeof object.leftBetInfo[i] !== "object")
                        throw TypeError(".BlackJack.EnableRightNotify.leftBetInfo: object expected");
                    message.leftBetInfo[i] = $root.BlackJack.EnableRightNotify.BetInfo.fromObject(object.leftBetInfo[i]);
                }
            }
            if (object.rightBetInfo) {
                if (!Array.isArray(object.rightBetInfo))
                    throw TypeError(".BlackJack.EnableRightNotify.rightBetInfo: array expected");
                message.rightBetInfo = [];
                for (var i = 0; i < object.rightBetInfo.length; ++i) {
                    if (typeof object.rightBetInfo[i] !== "object")
                        throw TypeError(".BlackJack.EnableRightNotify.rightBetInfo: object expected");
                    message.rightBetInfo[i] = $root.BlackJack.EnableRightNotify.BetInfo.fromObject(object.rightBetInfo[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an EnableRightNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.EnableRightNotify
         * @static
         * @param {BlackJack.EnableRightNotify} message EnableRightNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnableRightNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.leftBetInfo = [];
                object.rightBetInfo = [];
            }
            if (options.defaults) {
                object.pos = 0;
                object.playerId = 0;
                object.leftCardInfo = null;
                object.rightCardInfo = null;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.leftCardInfo != null && message.hasOwnProperty("leftCardInfo"))
                object.leftCardInfo = $root.BlackJack.CardInfo.toObject(message.leftCardInfo, options);
            if (message.rightCardInfo != null && message.hasOwnProperty("rightCardInfo"))
                object.rightCardInfo = $root.BlackJack.CardInfo.toObject(message.rightCardInfo, options);
            if (message.leftBetInfo && message.leftBetInfo.length) {
                object.leftBetInfo = [];
                for (var j = 0; j < message.leftBetInfo.length; ++j)
                    object.leftBetInfo[j] = $root.BlackJack.EnableRightNotify.BetInfo.toObject(message.leftBetInfo[j], options);
            }
            if (message.rightBetInfo && message.rightBetInfo.length) {
                object.rightBetInfo = [];
                for (var j = 0; j < message.rightBetInfo.length; ++j)
                    object.rightBetInfo[j] = $root.BlackJack.EnableRightNotify.BetInfo.toObject(message.rightBetInfo[j], options);
            }
            return object;
        };

        /**
         * Converts this EnableRightNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.EnableRightNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnableRightNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        EnableRightNotify.BetInfo = (function() {

            /**
             * Properties of a BetInfo.
             * @memberof BlackJack.EnableRightNotify
             * @interface IBetInfo
             * @property {number|null} [bet] BetInfo bet
             * @property {number|null} [playerId] BetInfo playerId
             * @property {number|null} [coinBalance] BetInfo coinBalance
             */

            /**
             * Constructs a new BetInfo.
             * @memberof BlackJack.EnableRightNotify
             * @classdesc Represents a BetInfo.
             * @implements IBetInfo
             * @constructor
             * @param {BlackJack.EnableRightNotify.IBetInfo=} [properties] Properties to set
             */
            function BetInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetInfo bet.
             * @member {number} bet
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.bet = 0;

            /**
             * BetInfo playerId.
             * @member {number} playerId
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.playerId = 0;

            /**
             * BetInfo coinBalance.
             * @member {number} coinBalance
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.coinBalance = 0;

            /**
             * Creates a new BetInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {BlackJack.EnableRightNotify.IBetInfo=} [properties] Properties to set
             * @returns {BlackJack.EnableRightNotify.BetInfo} BetInfo instance
             */
            BetInfo.create = function create(properties) {
                return new BetInfo(properties);
            };

            /**
             * Encodes the specified BetInfo message. Does not implicitly {@link BlackJack.EnableRightNotify.BetInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {BlackJack.EnableRightNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.bet != null && message.hasOwnProperty("bet"))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.bet);
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerId);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.coinBalance);
                return writer;
            };

            /**
             * Encodes the specified BetInfo message, length delimited. Does not implicitly {@link BlackJack.EnableRightNotify.BetInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {BlackJack.EnableRightNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.EnableRightNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.EnableRightNotify.BetInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.bet = reader.double();
                        break;
                    case 2:
                        message.playerId = reader.int32();
                        break;
                    case 3:
                        message.coinBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.EnableRightNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetInfo message.
             * @function verify
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.bet != null && message.hasOwnProperty("bet"))
                    if (typeof message.bet !== "number")
                        return "bet: number expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                return null;
            };

            /**
             * Creates a BetInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.EnableRightNotify.BetInfo} BetInfo
             */
            BetInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.EnableRightNotify.BetInfo)
                    return object;
                var message = new $root.BlackJack.EnableRightNotify.BetInfo();
                if (object.bet != null)
                    message.bet = Number(object.bet);
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                return message;
            };

            /**
             * Creates a plain object from a BetInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @static
             * @param {BlackJack.EnableRightNotify.BetInfo} message BetInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.bet = 0;
                    object.playerId = 0;
                    object.coinBalance = 0;
                }
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                return object;
            };

            /**
             * Converts this BetInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.EnableRightNotify.BetInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BetInfo;
        })();

        return EnableRightNotify;
    })();

    BlackJack.MoreCardReq = (function() {

        /**
         * Properties of a MoreCardReq.
         * @memberof BlackJack
         * @interface IMoreCardReq
         * @property {number|null} [pos] MoreCardReq pos
         */

        /**
         * Constructs a new MoreCardReq.
         * @memberof BlackJack
         * @classdesc Represents a MoreCardReq.
         * @implements IMoreCardReq
         * @constructor
         * @param {BlackJack.IMoreCardReq=} [properties] Properties to set
         */
        function MoreCardReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardReq pos.
         * @member {number} pos
         * @memberof BlackJack.MoreCardReq
         * @instance
         */
        MoreCardReq.prototype.pos = 0;

        /**
         * Creates a new MoreCardReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {BlackJack.IMoreCardReq=} [properties] Properties to set
         * @returns {BlackJack.MoreCardReq} MoreCardReq instance
         */
        MoreCardReq.create = function create(properties) {
            return new MoreCardReq(properties);
        };

        /**
         * Encodes the specified MoreCardReq message. Does not implicitly {@link BlackJack.MoreCardReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {BlackJack.IMoreCardReq} message MoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified MoreCardReq message, length delimited. Does not implicitly {@link BlackJack.MoreCardReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {BlackJack.IMoreCardReq} message MoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.MoreCardReq} MoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.MoreCardReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.MoreCardReq} MoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardReq message.
         * @function verify
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a MoreCardReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.MoreCardReq} MoreCardReq
         */
        MoreCardReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.MoreCardReq)
                return object;
            var message = new $root.BlackJack.MoreCardReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a MoreCardReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.MoreCardReq
         * @static
         * @param {BlackJack.MoreCardReq} message MoreCardReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pos = 0;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this MoreCardReq to JSON.
         * @function toJSON
         * @memberof BlackJack.MoreCardReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardReq;
    })();

    BlackJack.MoreCardRsp = (function() {

        /**
         * Properties of a MoreCardRsp.
         * @memberof BlackJack
         * @interface IMoreCardRsp
         * @property {number|null} [errNo] MoreCardRsp errNo
         * @property {number|null} [pos] MoreCardRsp pos
         */

        /**
         * Constructs a new MoreCardRsp.
         * @memberof BlackJack
         * @classdesc Represents a MoreCardRsp.
         * @implements IMoreCardRsp
         * @constructor
         * @param {BlackJack.IMoreCardRsp=} [properties] Properties to set
         */
        function MoreCardRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.MoreCardRsp
         * @instance
         */
        MoreCardRsp.prototype.errNo = 0;

        /**
         * MoreCardRsp pos.
         * @member {number} pos
         * @memberof BlackJack.MoreCardRsp
         * @instance
         */
        MoreCardRsp.prototype.pos = 0;

        /**
         * Creates a new MoreCardRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {BlackJack.IMoreCardRsp=} [properties] Properties to set
         * @returns {BlackJack.MoreCardRsp} MoreCardRsp instance
         */
        MoreCardRsp.create = function create(properties) {
            return new MoreCardRsp(properties);
        };

        /**
         * Encodes the specified MoreCardRsp message. Does not implicitly {@link BlackJack.MoreCardRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {BlackJack.IMoreCardRsp} message MoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified MoreCardRsp message, length delimited. Does not implicitly {@link BlackJack.MoreCardRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {BlackJack.IMoreCardRsp} message MoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.MoreCardRsp} MoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.MoreCardRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 8:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.MoreCardRsp} MoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardRsp message.
         * @function verify
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a MoreCardRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.MoreCardRsp} MoreCardRsp
         */
        MoreCardRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.MoreCardRsp)
                return object;
            var message = new $root.BlackJack.MoreCardRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a MoreCardRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.MoreCardRsp
         * @static
         * @param {BlackJack.MoreCardRsp} message MoreCardRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.pos = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this MoreCardRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.MoreCardRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardRsp;
    })();

    BlackJack.MoreCardNotify = (function() {

        /**
         * Properties of a MoreCardNotify.
         * @memberof BlackJack
         * @interface IMoreCardNotify
         * @property {number|null} [pos] MoreCardNotify pos
         * @property {BlackJack.ICardInfo|null} [cardInfo] MoreCardNotify cardInfo
         * @property {number|null} [nextPos] MoreCardNotify nextPos
         */

        /**
         * Constructs a new MoreCardNotify.
         * @memberof BlackJack
         * @classdesc Represents a MoreCardNotify.
         * @implements IMoreCardNotify
         * @constructor
         * @param {BlackJack.IMoreCardNotify=} [properties] Properties to set
         */
        function MoreCardNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MoreCardNotify pos.
         * @member {number} pos
         * @memberof BlackJack.MoreCardNotify
         * @instance
         */
        MoreCardNotify.prototype.pos = 0;

        /**
         * MoreCardNotify cardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} cardInfo
         * @memberof BlackJack.MoreCardNotify
         * @instance
         */
        MoreCardNotify.prototype.cardInfo = null;

        /**
         * MoreCardNotify nextPos.
         * @member {number} nextPos
         * @memberof BlackJack.MoreCardNotify
         * @instance
         */
        MoreCardNotify.prototype.nextPos = 0;

        /**
         * Creates a new MoreCardNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {BlackJack.IMoreCardNotify=} [properties] Properties to set
         * @returns {BlackJack.MoreCardNotify} MoreCardNotify instance
         */
        MoreCardNotify.create = function create(properties) {
            return new MoreCardNotify(properties);
        };

        /**
         * Encodes the specified MoreCardNotify message. Does not implicitly {@link BlackJack.MoreCardNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {BlackJack.IMoreCardNotify} message MoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                $root.BlackJack.CardInfo.encode(message.cardInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.nextPos);
            return writer;
        };

        /**
         * Encodes the specified MoreCardNotify message, length delimited. Does not implicitly {@link BlackJack.MoreCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {BlackJack.IMoreCardNotify} message MoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MoreCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MoreCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.MoreCardNotify} MoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.MoreCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.cardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextPos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MoreCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.MoreCardNotify} MoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MoreCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MoreCardNotify message.
         * @function verify
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MoreCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.cardInfo);
                if (error)
                    return "cardInfo." + error;
            }
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                if (!$util.isInteger(message.nextPos))
                    return "nextPos: integer expected";
            return null;
        };

        /**
         * Creates a MoreCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.MoreCardNotify} MoreCardNotify
         */
        MoreCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.MoreCardNotify)
                return object;
            var message = new $root.BlackJack.MoreCardNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.cardInfo != null) {
                if (typeof object.cardInfo !== "object")
                    throw TypeError(".BlackJack.MoreCardNotify.cardInfo: object expected");
                message.cardInfo = $root.BlackJack.CardInfo.fromObject(object.cardInfo);
            }
            if (object.nextPos != null)
                message.nextPos = object.nextPos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a MoreCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.MoreCardNotify
         * @static
         * @param {BlackJack.MoreCardNotify} message MoreCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MoreCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.cardInfo = null;
                object.nextPos = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                object.cardInfo = $root.BlackJack.CardInfo.toObject(message.cardInfo, options);
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                object.nextPos = message.nextPos;
            return object;
        };

        /**
         * Converts this MoreCardNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.MoreCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MoreCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MoreCardNotify;
    })();

    BlackJack.NoMoreCardReq = (function() {

        /**
         * Properties of a NoMoreCardReq.
         * @memberof BlackJack
         * @interface INoMoreCardReq
         * @property {number|null} [pos] NoMoreCardReq pos
         */

        /**
         * Constructs a new NoMoreCardReq.
         * @memberof BlackJack
         * @classdesc Represents a NoMoreCardReq.
         * @implements INoMoreCardReq
         * @constructor
         * @param {BlackJack.INoMoreCardReq=} [properties] Properties to set
         */
        function NoMoreCardReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoMoreCardReq pos.
         * @member {number} pos
         * @memberof BlackJack.NoMoreCardReq
         * @instance
         */
        NoMoreCardReq.prototype.pos = 0;

        /**
         * Creates a new NoMoreCardReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {BlackJack.INoMoreCardReq=} [properties] Properties to set
         * @returns {BlackJack.NoMoreCardReq} NoMoreCardReq instance
         */
        NoMoreCardReq.create = function create(properties) {
            return new NoMoreCardReq(properties);
        };

        /**
         * Encodes the specified NoMoreCardReq message. Does not implicitly {@link BlackJack.NoMoreCardReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {BlackJack.INoMoreCardReq} message NoMoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified NoMoreCardReq message, length delimited. Does not implicitly {@link BlackJack.NoMoreCardReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {BlackJack.INoMoreCardReq} message NoMoreCardReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoMoreCardReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.NoMoreCardReq} NoMoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.NoMoreCardReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NoMoreCardReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.NoMoreCardReq} NoMoreCardReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoMoreCardReq message.
         * @function verify
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoMoreCardReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a NoMoreCardReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.NoMoreCardReq} NoMoreCardReq
         */
        NoMoreCardReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.NoMoreCardReq)
                return object;
            var message = new $root.BlackJack.NoMoreCardReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a NoMoreCardReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.NoMoreCardReq
         * @static
         * @param {BlackJack.NoMoreCardReq} message NoMoreCardReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoMoreCardReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pos = 0;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this NoMoreCardReq to JSON.
         * @function toJSON
         * @memberof BlackJack.NoMoreCardReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoMoreCardReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoMoreCardReq;
    })();

    BlackJack.NoMoreCardRsp = (function() {

        /**
         * Properties of a NoMoreCardRsp.
         * @memberof BlackJack
         * @interface INoMoreCardRsp
         * @property {number|null} [errNo] NoMoreCardRsp errNo
         * @property {number|null} [pos] NoMoreCardRsp pos
         */

        /**
         * Constructs a new NoMoreCardRsp.
         * @memberof BlackJack
         * @classdesc Represents a NoMoreCardRsp.
         * @implements INoMoreCardRsp
         * @constructor
         * @param {BlackJack.INoMoreCardRsp=} [properties] Properties to set
         */
        function NoMoreCardRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoMoreCardRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.NoMoreCardRsp
         * @instance
         */
        NoMoreCardRsp.prototype.errNo = 0;

        /**
         * NoMoreCardRsp pos.
         * @member {number} pos
         * @memberof BlackJack.NoMoreCardRsp
         * @instance
         */
        NoMoreCardRsp.prototype.pos = 0;

        /**
         * Creates a new NoMoreCardRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {BlackJack.INoMoreCardRsp=} [properties] Properties to set
         * @returns {BlackJack.NoMoreCardRsp} NoMoreCardRsp instance
         */
        NoMoreCardRsp.create = function create(properties) {
            return new NoMoreCardRsp(properties);
        };

        /**
         * Encodes the specified NoMoreCardRsp message. Does not implicitly {@link BlackJack.NoMoreCardRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {BlackJack.INoMoreCardRsp} message NoMoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.pos);
            return writer;
        };

        /**
         * Encodes the specified NoMoreCardRsp message, length delimited. Does not implicitly {@link BlackJack.NoMoreCardRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {BlackJack.INoMoreCardRsp} message NoMoreCardRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoMoreCardRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.NoMoreCardRsp} NoMoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.NoMoreCardRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                case 8:
                    message.pos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NoMoreCardRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.NoMoreCardRsp} NoMoreCardRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoMoreCardRsp message.
         * @function verify
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoMoreCardRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            return null;
        };

        /**
         * Creates a NoMoreCardRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.NoMoreCardRsp} NoMoreCardRsp
         */
        NoMoreCardRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.NoMoreCardRsp)
                return object;
            var message = new $root.BlackJack.NoMoreCardRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a NoMoreCardRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.NoMoreCardRsp
         * @static
         * @param {BlackJack.NoMoreCardRsp} message NoMoreCardRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoMoreCardRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = 0;
                object.pos = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            return object;
        };

        /**
         * Converts this NoMoreCardRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.NoMoreCardRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoMoreCardRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoMoreCardRsp;
    })();

    BlackJack.NoMoreCardNotify = (function() {

        /**
         * Properties of a NoMoreCardNotify.
         * @memberof BlackJack
         * @interface INoMoreCardNotify
         * @property {number|null} [pos] NoMoreCardNotify pos
         * @property {BlackJack.ICardInfo|null} [cardInfo] NoMoreCardNotify cardInfo
         * @property {number|null} [nextPos] NoMoreCardNotify nextPos
         */

        /**
         * Constructs a new NoMoreCardNotify.
         * @memberof BlackJack
         * @classdesc Represents a NoMoreCardNotify.
         * @implements INoMoreCardNotify
         * @constructor
         * @param {BlackJack.INoMoreCardNotify=} [properties] Properties to set
         */
        function NoMoreCardNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoMoreCardNotify pos.
         * @member {number} pos
         * @memberof BlackJack.NoMoreCardNotify
         * @instance
         */
        NoMoreCardNotify.prototype.pos = 0;

        /**
         * NoMoreCardNotify cardInfo.
         * @member {BlackJack.ICardInfo|null|undefined} cardInfo
         * @memberof BlackJack.NoMoreCardNotify
         * @instance
         */
        NoMoreCardNotify.prototype.cardInfo = null;

        /**
         * NoMoreCardNotify nextPos.
         * @member {number} nextPos
         * @memberof BlackJack.NoMoreCardNotify
         * @instance
         */
        NoMoreCardNotify.prototype.nextPos = 0;

        /**
         * Creates a new NoMoreCardNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {BlackJack.INoMoreCardNotify=} [properties] Properties to set
         * @returns {BlackJack.NoMoreCardNotify} NoMoreCardNotify instance
         */
        NoMoreCardNotify.create = function create(properties) {
            return new NoMoreCardNotify(properties);
        };

        /**
         * Encodes the specified NoMoreCardNotify message. Does not implicitly {@link BlackJack.NoMoreCardNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {BlackJack.INoMoreCardNotify} message NoMoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                $root.BlackJack.CardInfo.encode(message.cardInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.nextPos);
            return writer;
        };

        /**
         * Encodes the specified NoMoreCardNotify message, length delimited. Does not implicitly {@link BlackJack.NoMoreCardNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {BlackJack.INoMoreCardNotify} message NoMoreCardNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoMoreCardNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoMoreCardNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.NoMoreCardNotify} NoMoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.NoMoreCardNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.cardInfo = $root.BlackJack.CardInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextPos = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NoMoreCardNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.NoMoreCardNotify} NoMoreCardNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoMoreCardNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoMoreCardNotify message.
         * @function verify
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoMoreCardNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo")) {
                var error = $root.BlackJack.CardInfo.verify(message.cardInfo);
                if (error)
                    return "cardInfo." + error;
            }
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                if (!$util.isInteger(message.nextPos))
                    return "nextPos: integer expected";
            return null;
        };

        /**
         * Creates a NoMoreCardNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.NoMoreCardNotify} NoMoreCardNotify
         */
        NoMoreCardNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.NoMoreCardNotify)
                return object;
            var message = new $root.BlackJack.NoMoreCardNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.cardInfo != null) {
                if (typeof object.cardInfo !== "object")
                    throw TypeError(".BlackJack.NoMoreCardNotify.cardInfo: object expected");
                message.cardInfo = $root.BlackJack.CardInfo.fromObject(object.cardInfo);
            }
            if (object.nextPos != null)
                message.nextPos = object.nextPos >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a NoMoreCardNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.NoMoreCardNotify
         * @static
         * @param {BlackJack.NoMoreCardNotify} message NoMoreCardNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoMoreCardNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.cardInfo = null;
                object.nextPos = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.cardInfo != null && message.hasOwnProperty("cardInfo"))
                object.cardInfo = $root.BlackJack.CardInfo.toObject(message.cardInfo, options);
            if (message.nextPos != null && message.hasOwnProperty("nextPos"))
                object.nextPos = message.nextPos;
            return object;
        };

        /**
         * Converts this NoMoreCardNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.NoMoreCardNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoMoreCardNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoMoreCardNotify;
    })();

    BlackJack.InsuranceReq = (function() {

        /**
         * Properties of an InsuranceReq.
         * @memberof BlackJack
         * @interface IInsuranceReq
         * @property {number|null} [pos] InsuranceReq pos
         * @property {boolean|null} [rejected] InsuranceReq rejected
         */

        /**
         * Constructs a new InsuranceReq.
         * @memberof BlackJack
         * @classdesc Represents an InsuranceReq.
         * @implements IInsuranceReq
         * @constructor
         * @param {BlackJack.IInsuranceReq=} [properties] Properties to set
         */
        function InsuranceReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InsuranceReq pos.
         * @member {number} pos
         * @memberof BlackJack.InsuranceReq
         * @instance
         */
        InsuranceReq.prototype.pos = 0;

        /**
         * InsuranceReq rejected.
         * @member {boolean} rejected
         * @memberof BlackJack.InsuranceReq
         * @instance
         */
        InsuranceReq.prototype.rejected = false;

        /**
         * Creates a new InsuranceReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {BlackJack.IInsuranceReq=} [properties] Properties to set
         * @returns {BlackJack.InsuranceReq} InsuranceReq instance
         */
        InsuranceReq.create = function create(properties) {
            return new InsuranceReq(properties);
        };

        /**
         * Encodes the specified InsuranceReq message. Does not implicitly {@link BlackJack.InsuranceReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {BlackJack.IInsuranceReq} message InsuranceReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.rejected != null && message.hasOwnProperty("rejected"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.rejected);
            return writer;
        };

        /**
         * Encodes the specified InsuranceReq message, length delimited. Does not implicitly {@link BlackJack.InsuranceReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {BlackJack.IInsuranceReq} message InsuranceReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InsuranceReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.InsuranceReq} InsuranceReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.InsuranceReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 2:
                    message.rejected = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InsuranceReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.InsuranceReq} InsuranceReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InsuranceReq message.
         * @function verify
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InsuranceReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.rejected != null && message.hasOwnProperty("rejected"))
                if (typeof message.rejected !== "boolean")
                    return "rejected: boolean expected";
            return null;
        };

        /**
         * Creates an InsuranceReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.InsuranceReq} InsuranceReq
         */
        InsuranceReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.InsuranceReq)
                return object;
            var message = new $root.BlackJack.InsuranceReq();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.rejected != null)
                message.rejected = Boolean(object.rejected);
            return message;
        };

        /**
         * Creates a plain object from an InsuranceReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.InsuranceReq
         * @static
         * @param {BlackJack.InsuranceReq} message InsuranceReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InsuranceReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.rejected = false;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.rejected != null && message.hasOwnProperty("rejected"))
                object.rejected = message.rejected;
            return object;
        };

        /**
         * Converts this InsuranceReq to JSON.
         * @function toJSON
         * @memberof BlackJack.InsuranceReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InsuranceReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InsuranceReq;
    })();

    BlackJack.InsuranceRsp = (function() {

        /**
         * Properties of an InsuranceRsp.
         * @memberof BlackJack
         * @interface IInsuranceRsp
         * @property {number|null} [errNo] InsuranceRsp errNo
         */

        /**
         * Constructs a new InsuranceRsp.
         * @memberof BlackJack
         * @classdesc Represents an InsuranceRsp.
         * @implements IInsuranceRsp
         * @constructor
         * @param {BlackJack.IInsuranceRsp=} [properties] Properties to set
         */
        function InsuranceRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InsuranceRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.InsuranceRsp
         * @instance
         */
        InsuranceRsp.prototype.errNo = 0;

        /**
         * Creates a new InsuranceRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {BlackJack.IInsuranceRsp=} [properties] Properties to set
         * @returns {BlackJack.InsuranceRsp} InsuranceRsp instance
         */
        InsuranceRsp.create = function create(properties) {
            return new InsuranceRsp(properties);
        };

        /**
         * Encodes the specified InsuranceRsp message. Does not implicitly {@link BlackJack.InsuranceRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {BlackJack.IInsuranceRsp} message InsuranceRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified InsuranceRsp message, length delimited. Does not implicitly {@link BlackJack.InsuranceRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {BlackJack.IInsuranceRsp} message InsuranceRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InsuranceRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.InsuranceRsp} InsuranceRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.InsuranceRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InsuranceRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.InsuranceRsp} InsuranceRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InsuranceRsp message.
         * @function verify
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InsuranceRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates an InsuranceRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.InsuranceRsp} InsuranceRsp
         */
        InsuranceRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.InsuranceRsp)
                return object;
            var message = new $root.BlackJack.InsuranceRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from an InsuranceRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.InsuranceRsp
         * @static
         * @param {BlackJack.InsuranceRsp} message InsuranceRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InsuranceRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this InsuranceRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.InsuranceRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InsuranceRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InsuranceRsp;
    })();

    BlackJack.InsuranceNotify = (function() {

        /**
         * Properties of an InsuranceNotify.
         * @memberof BlackJack
         * @interface IInsuranceNotify
         * @property {number|null} [pos] InsuranceNotify pos
         * @property {number|null} [playerId] InsuranceNotify playerId
         * @property {number|null} [insurance] InsuranceNotify insurance
         * @property {number|null} [coinBalance] InsuranceNotify coinBalance
         */

        /**
         * Constructs a new InsuranceNotify.
         * @memberof BlackJack
         * @classdesc Represents an InsuranceNotify.
         * @implements IInsuranceNotify
         * @constructor
         * @param {BlackJack.IInsuranceNotify=} [properties] Properties to set
         */
        function InsuranceNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InsuranceNotify pos.
         * @member {number} pos
         * @memberof BlackJack.InsuranceNotify
         * @instance
         */
        InsuranceNotify.prototype.pos = 0;

        /**
         * InsuranceNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.InsuranceNotify
         * @instance
         */
        InsuranceNotify.prototype.playerId = 0;

        /**
         * InsuranceNotify insurance.
         * @member {number} insurance
         * @memberof BlackJack.InsuranceNotify
         * @instance
         */
        InsuranceNotify.prototype.insurance = 0;

        /**
         * InsuranceNotify coinBalance.
         * @member {number} coinBalance
         * @memberof BlackJack.InsuranceNotify
         * @instance
         */
        InsuranceNotify.prototype.coinBalance = 0;

        /**
         * Creates a new InsuranceNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {BlackJack.IInsuranceNotify=} [properties] Properties to set
         * @returns {BlackJack.InsuranceNotify} InsuranceNotify instance
         */
        InsuranceNotify.create = function create(properties) {
            return new InsuranceNotify(properties);
        };

        /**
         * Encodes the specified InsuranceNotify message. Does not implicitly {@link BlackJack.InsuranceNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {BlackJack.IInsuranceNotify} message InsuranceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.insurance);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified InsuranceNotify message, length delimited. Does not implicitly {@link BlackJack.InsuranceNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {BlackJack.IInsuranceNotify} message InsuranceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InsuranceNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InsuranceNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.InsuranceNotify} InsuranceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.InsuranceNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pos = reader.uint32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.insurance = reader.double();
                    break;
                case 4:
                    message.coinBalance = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InsuranceNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.InsuranceNotify} InsuranceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InsuranceNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InsuranceNotify message.
         * @function verify
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InsuranceNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                if (typeof message.insurance !== "number")
                    return "insurance: number expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            return null;
        };

        /**
         * Creates an InsuranceNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.InsuranceNotify} InsuranceNotify
         */
        InsuranceNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.InsuranceNotify)
                return object;
            var message = new $root.BlackJack.InsuranceNotify();
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.insurance != null)
                message.insurance = Number(object.insurance);
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            return message;
        };

        /**
         * Creates a plain object from an InsuranceNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.InsuranceNotify
         * @static
         * @param {BlackJack.InsuranceNotify} message InsuranceNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InsuranceNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pos = 0;
                object.insurance = 0;
                object.playerId = 0;
                object.coinBalance = 0;
            }
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.insurance != null && message.hasOwnProperty("insurance"))
                object.insurance = options.json && !isFinite(message.insurance) ? String(message.insurance) : message.insurance;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this InsuranceNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.InsuranceNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InsuranceNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InsuranceNotify;
    })();

    BlackJack.BetFinishReq = (function() {

        /**
         * Properties of a BetFinishReq.
         * @memberof BlackJack
         * @interface IBetFinishReq
         * @property {number|null} [seatId] BetFinishReq seatId
         */

        /**
         * Constructs a new BetFinishReq.
         * @memberof BlackJack
         * @classdesc Represents a BetFinishReq.
         * @implements IBetFinishReq
         * @constructor
         * @param {BlackJack.IBetFinishReq=} [properties] Properties to set
         */
        function BetFinishReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetFinishReq seatId.
         * @member {number} seatId
         * @memberof BlackJack.BetFinishReq
         * @instance
         */
        BetFinishReq.prototype.seatId = 0;

        /**
         * Creates a new BetFinishReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {BlackJack.IBetFinishReq=} [properties] Properties to set
         * @returns {BlackJack.BetFinishReq} BetFinishReq instance
         */
        BetFinishReq.create = function create(properties) {
            return new BetFinishReq(properties);
        };

        /**
         * Encodes the specified BetFinishReq message. Does not implicitly {@link BlackJack.BetFinishReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {BlackJack.IBetFinishReq} message BetFinishReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            return writer;
        };

        /**
         * Encodes the specified BetFinishReq message, length delimited. Does not implicitly {@link BlackJack.BetFinishReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {BlackJack.IBetFinishReq} message BetFinishReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetFinishReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetFinishReq} BetFinishReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetFinishReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetFinishReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetFinishReq} BetFinishReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetFinishReq message.
         * @function verify
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetFinishReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a BetFinishReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetFinishReq} BetFinishReq
         */
        BetFinishReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetFinishReq)
                return object;
            var message = new $root.BlackJack.BetFinishReq();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BetFinishReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetFinishReq
         * @static
         * @param {BlackJack.BetFinishReq} message BetFinishReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetFinishReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatId = 0;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            return object;
        };

        /**
         * Converts this BetFinishReq to JSON.
         * @function toJSON
         * @memberof BlackJack.BetFinishReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetFinishReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetFinishReq;
    })();

    BlackJack.BetFinishRsp = (function() {

        /**
         * Properties of a BetFinishRsp.
         * @memberof BlackJack
         * @interface IBetFinishRsp
         * @property {number|null} [errNo] BetFinishRsp errNo
         */

        /**
         * Constructs a new BetFinishRsp.
         * @memberof BlackJack
         * @classdesc Represents a BetFinishRsp.
         * @implements IBetFinishRsp
         * @constructor
         * @param {BlackJack.IBetFinishRsp=} [properties] Properties to set
         */
        function BetFinishRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetFinishRsp errNo.
         * @member {number} errNo
         * @memberof BlackJack.BetFinishRsp
         * @instance
         */
        BetFinishRsp.prototype.errNo = 0;

        /**
         * Creates a new BetFinishRsp instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {BlackJack.IBetFinishRsp=} [properties] Properties to set
         * @returns {BlackJack.BetFinishRsp} BetFinishRsp instance
         */
        BetFinishRsp.create = function create(properties) {
            return new BetFinishRsp(properties);
        };

        /**
         * Encodes the specified BetFinishRsp message. Does not implicitly {@link BlackJack.BetFinishRsp.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {BlackJack.IBetFinishRsp} message BetFinishRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified BetFinishRsp message, length delimited. Does not implicitly {@link BlackJack.BetFinishRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {BlackJack.IBetFinishRsp} message BetFinishRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetFinishRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetFinishRsp} BetFinishRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetFinishRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetFinishRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetFinishRsp} BetFinishRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetFinishRsp message.
         * @function verify
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetFinishRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isInteger(message.errNo))
                    return "errNo: integer expected";
            return null;
        };

        /**
         * Creates a BetFinishRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetFinishRsp} BetFinishRsp
         */
        BetFinishRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetFinishRsp)
                return object;
            var message = new $root.BlackJack.BetFinishRsp();
            if (object.errNo != null)
                message.errNo = object.errNo | 0;
            return message;
        };

        /**
         * Creates a plain object from a BetFinishRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetFinishRsp
         * @static
         * @param {BlackJack.BetFinishRsp} message BetFinishRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetFinishRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = 0;
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this BetFinishRsp to JSON.
         * @function toJSON
         * @memberof BlackJack.BetFinishRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetFinishRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetFinishRsp;
    })();

    BlackJack.BetFinishNotify = (function() {

        /**
         * Properties of a BetFinishNotify.
         * @memberof BlackJack
         * @interface IBetFinishNotify
         * @property {number|null} [seatId] BetFinishNotify seatId
         */

        /**
         * Constructs a new BetFinishNotify.
         * @memberof BlackJack
         * @classdesc Represents a BetFinishNotify.
         * @implements IBetFinishNotify
         * @constructor
         * @param {BlackJack.IBetFinishNotify=} [properties] Properties to set
         */
        function BetFinishNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetFinishNotify seatId.
         * @member {number} seatId
         * @memberof BlackJack.BetFinishNotify
         * @instance
         */
        BetFinishNotify.prototype.seatId = 0;

        /**
         * Creates a new BetFinishNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {BlackJack.IBetFinishNotify=} [properties] Properties to set
         * @returns {BlackJack.BetFinishNotify} BetFinishNotify instance
         */
        BetFinishNotify.create = function create(properties) {
            return new BetFinishNotify(properties);
        };

        /**
         * Encodes the specified BetFinishNotify message. Does not implicitly {@link BlackJack.BetFinishNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {BlackJack.IBetFinishNotify} message BetFinishNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.seatId);
            return writer;
        };

        /**
         * Encodes the specified BetFinishNotify message, length delimited. Does not implicitly {@link BlackJack.BetFinishNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {BlackJack.IBetFinishNotify} message BetFinishNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetFinishNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetFinishNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.BetFinishNotify} BetFinishNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.BetFinishNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.seatId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetFinishNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.BetFinishNotify} BetFinishNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetFinishNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetFinishNotify message.
         * @function verify
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetFinishNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                if (!$util.isInteger(message.seatId))
                    return "seatId: integer expected";
            return null;
        };

        /**
         * Creates a BetFinishNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.BetFinishNotify} BetFinishNotify
         */
        BetFinishNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.BetFinishNotify)
                return object;
            var message = new $root.BlackJack.BetFinishNotify();
            if (object.seatId != null)
                message.seatId = object.seatId >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a BetFinishNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.BetFinishNotify
         * @static
         * @param {BlackJack.BetFinishNotify} message BetFinishNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetFinishNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.seatId = 0;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            return object;
        };

        /**
         * Converts this BetFinishNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.BetFinishNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetFinishNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetFinishNotify;
    })();

    BlackJack.GameSettle = (function() {

        /**
         * Properties of a GameSettle.
         * @memberof BlackJack
         * @interface IGameSettle
         * @property {Array.<BlackJack.GameSettle.IPlayer>|null} [players] GameSettle players
         * @property {Array.<BlackJack.GameSettle.IPosInfo>|null} [posInfo] GameSettle posInfo
         * @property {Array.<number>|null} [bankerCards] GameSettle bankerCards
         * @property {number|null} [bankerCardPoint] GameSettle bankerCardPoint
         * @property {number|null} [reason] GameSettle reason
         */

        /**
         * Constructs a new GameSettle.
         * @memberof BlackJack
         * @classdesc Represents a GameSettle.
         * @implements IGameSettle
         * @constructor
         * @param {BlackJack.IGameSettle=} [properties] Properties to set
         */
        function GameSettle(properties) {
            this.players = [];
            this.posInfo = [];
            this.bankerCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameSettle players.
         * @member {Array.<BlackJack.GameSettle.IPlayer>} players
         * @memberof BlackJack.GameSettle
         * @instance
         */
        GameSettle.prototype.players = $util.emptyArray;

        /**
         * GameSettle posInfo.
         * @member {Array.<BlackJack.GameSettle.IPosInfo>} posInfo
         * @memberof BlackJack.GameSettle
         * @instance
         */
        GameSettle.prototype.posInfo = $util.emptyArray;

        /**
         * GameSettle bankerCards.
         * @member {Array.<number>} bankerCards
         * @memberof BlackJack.GameSettle
         * @instance
         */
        GameSettle.prototype.bankerCards = $util.emptyArray;

        /**
         * GameSettle bankerCardPoint.
         * @member {number} bankerCardPoint
         * @memberof BlackJack.GameSettle
         * @instance
         */
        GameSettle.prototype.bankerCardPoint = 0;

        /**
         * GameSettle reason.
         * @member {number} reason
         * @memberof BlackJack.GameSettle
         * @instance
         */
        GameSettle.prototype.reason = 0;

        /**
         * Creates a new GameSettle instance using the specified properties.
         * @function create
         * @memberof BlackJack.GameSettle
         * @static
         * @param {BlackJack.IGameSettle=} [properties] Properties to set
         * @returns {BlackJack.GameSettle} GameSettle instance
         */
        GameSettle.create = function create(properties) {
            return new GameSettle(properties);
        };

        /**
         * Encodes the specified GameSettle message. Does not implicitly {@link BlackJack.GameSettle.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.GameSettle
         * @static
         * @param {BlackJack.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.BlackJack.GameSettle.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.posInfo != null && message.posInfo.length)
                for (var i = 0; i < message.posInfo.length; ++i)
                    $root.BlackJack.GameSettle.PosInfo.encode(message.posInfo[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.bankerCards != null && message.bankerCards.length)
                for (var i = 0; i < message.bankerCards.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bankerCards[i]);
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.bankerCardPoint);
            if (message.reason != null && message.hasOwnProperty("reason"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.reason);
            return writer;
        };

        /**
         * Encodes the specified GameSettle message, length delimited. Does not implicitly {@link BlackJack.GameSettle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.GameSettle
         * @static
         * @param {BlackJack.IGameSettle} message GameSettle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.GameSettle();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.BlackJack.GameSettle.Player.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.posInfo && message.posInfo.length))
                        message.posInfo = [];
                    message.posInfo.push($root.BlackJack.GameSettle.PosInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.bankerCards && message.bankerCards.length))
                        message.bankerCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.bankerCards.push(reader.int32());
                    } else
                        message.bankerCards.push(reader.int32());
                    break;
                case 4:
                    message.bankerCardPoint = reader.int32();
                    break;
                case 5:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameSettle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.GameSettle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.GameSettle} GameSettle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameSettle message.
         * @function verify
         * @memberof BlackJack.GameSettle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameSettle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.BlackJack.GameSettle.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                if (!Array.isArray(message.posInfo))
                    return "posInfo: array expected";
                for (var i = 0; i < message.posInfo.length; ++i) {
                    var error = $root.BlackJack.GameSettle.PosInfo.verify(message.posInfo[i]);
                    if (error)
                        return "posInfo." + error;
                }
            }
            if (message.bankerCards != null && message.hasOwnProperty("bankerCards")) {
                if (!Array.isArray(message.bankerCards))
                    return "bankerCards: array expected";
                for (var i = 0; i < message.bankerCards.length; ++i)
                    if (!$util.isInteger(message.bankerCards[i]))
                        return "bankerCards: integer[] expected";
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                if (!$util.isInteger(message.bankerCardPoint))
                    return "bankerCardPoint: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isInteger(message.reason))
                    return "reason: integer expected";
            return null;
        };

        /**
         * Creates a GameSettle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.GameSettle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.GameSettle} GameSettle
         */
        GameSettle.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.GameSettle)
                return object;
            var message = new $root.BlackJack.GameSettle();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".BlackJack.GameSettle.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".BlackJack.GameSettle.players: object expected");
                    message.players[i] = $root.BlackJack.GameSettle.Player.fromObject(object.players[i]);
                }
            }
            if (object.posInfo) {
                if (!Array.isArray(object.posInfo))
                    throw TypeError(".BlackJack.GameSettle.posInfo: array expected");
                message.posInfo = [];
                for (var i = 0; i < object.posInfo.length; ++i) {
                    if (typeof object.posInfo[i] !== "object")
                        throw TypeError(".BlackJack.GameSettle.posInfo: object expected");
                    message.posInfo[i] = $root.BlackJack.GameSettle.PosInfo.fromObject(object.posInfo[i]);
                }
            }
            if (object.bankerCards) {
                if (!Array.isArray(object.bankerCards))
                    throw TypeError(".BlackJack.GameSettle.bankerCards: array expected");
                message.bankerCards = [];
                for (var i = 0; i < object.bankerCards.length; ++i)
                    message.bankerCards[i] = object.bankerCards[i] | 0;
            }
            if (object.bankerCardPoint != null)
                message.bankerCardPoint = object.bankerCardPoint | 0;
            if (object.reason != null)
                message.reason = object.reason | 0;
            return message;
        };

        /**
         * Creates a plain object from a GameSettle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.GameSettle
         * @static
         * @param {BlackJack.GameSettle} message GameSettle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameSettle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.players = [];
                object.posInfo = [];
                object.bankerCards = [];
            }
            if (options.defaults) {
                object.bankerCardPoint = 0;
                object.reason = 0;
            }
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.BlackJack.GameSettle.Player.toObject(message.players[j], options);
            }
            if (message.posInfo && message.posInfo.length) {
                object.posInfo = [];
                for (var j = 0; j < message.posInfo.length; ++j)
                    object.posInfo[j] = $root.BlackJack.GameSettle.PosInfo.toObject(message.posInfo[j], options);
            }
            if (message.bankerCards && message.bankerCards.length) {
                object.bankerCards = [];
                for (var j = 0; j < message.bankerCards.length; ++j)
                    object.bankerCards[j] = message.bankerCards[j];
            }
            if (message.bankerCardPoint != null && message.hasOwnProperty("bankerCardPoint"))
                object.bankerCardPoint = message.bankerCardPoint;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this GameSettle to JSON.
         * @function toJSON
         * @memberof BlackJack.GameSettle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameSettle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GameSettle.PosInfo = (function() {

            /**
             * Properties of a PosInfo.
             * @memberof BlackJack.GameSettle
             * @interface IPosInfo
             * @property {number|null} [pos] PosInfo pos
             * @property {Array.<number>|null} [cards] PosInfo cards
             * @property {Array.<number>|null} [cardPoint] PosInfo cardPoint
             * @property {number|null} [playerId] PosInfo playerId
             * @property {number|null} [bet] PosInfo bet
             * @property {number|null} [coinBalance] PosInfo coinBalance
             * @property {number|null} [balance] PosInfo balance
             * @property {number|null} [totalBalance] PosInfo totalBalance
             */

            /**
             * Constructs a new PosInfo.
             * @memberof BlackJack.GameSettle
             * @classdesc Represents a PosInfo.
             * @implements IPosInfo
             * @constructor
             * @param {BlackJack.GameSettle.IPosInfo=} [properties] Properties to set
             */
            function PosInfo(properties) {
                this.cards = [];
                this.cardPoint = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PosInfo pos.
             * @member {number} pos
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.pos = 0;

            /**
             * PosInfo cards.
             * @member {Array.<number>} cards
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.cards = $util.emptyArray;

            /**
             * PosInfo cardPoint.
             * @member {Array.<number>} cardPoint
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.cardPoint = $util.emptyArray;

            /**
             * PosInfo playerId.
             * @member {number} playerId
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.playerId = 0;

            /**
             * PosInfo bet.
             * @member {number} bet
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.bet = 0;

            /**
             * PosInfo coinBalance.
             * @member {number} coinBalance
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.coinBalance = 0;

            /**
             * PosInfo balance.
             * @member {number} balance
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.balance = 0;

            /**
             * PosInfo totalBalance.
             * @member {number} totalBalance
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             */
            PosInfo.prototype.totalBalance = 0;

            /**
             * Creates a new PosInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {BlackJack.GameSettle.IPosInfo=} [properties] Properties to set
             * @returns {BlackJack.GameSettle.PosInfo} PosInfo instance
             */
            PosInfo.create = function create(properties) {
                return new PosInfo(properties);
            };

            /**
             * Encodes the specified PosInfo message. Does not implicitly {@link BlackJack.GameSettle.PosInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {BlackJack.GameSettle.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
                if (message.cardPoint != null && message.cardPoint.length)
                    for (var i = 0; i < message.cardPoint.length; ++i)
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cardPoint[i]);
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
                if (message.balance != null && message.hasOwnProperty("balance"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.balance);
                if (message.cards != null && message.cards.length)
                    for (var i = 0; i < message.cards.length; ++i)
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cards[i]);
                if (message.bet != null && message.hasOwnProperty("bet"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.bet);
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.totalBalance);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 8, wireType 1 =*/65).double(message.coinBalance);
                return writer;
            };

            /**
             * Encodes the specified PosInfo message, length delimited. Does not implicitly {@link BlackJack.GameSettle.PosInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {BlackJack.GameSettle.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.GameSettle.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.GameSettle.PosInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.uint32();
                        break;
                    case 5:
                        if (!(message.cards && message.cards.length))
                            message.cards = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.cards.push(reader.int32());
                        } else
                            message.cards.push(reader.int32());
                        break;
                    case 2:
                        if (!(message.cardPoint && message.cardPoint.length))
                            message.cardPoint = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.cardPoint.push(reader.int32());
                        } else
                            message.cardPoint.push(reader.int32());
                        break;
                    case 3:
                        message.playerId = reader.int32();
                        break;
                    case 6:
                        message.bet = reader.double();
                        break;
                    case 8:
                        message.coinBalance = reader.double();
                        break;
                    case 4:
                        message.balance = reader.double();
                        break;
                    case 7:
                        message.totalBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.GameSettle.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PosInfo message.
             * @function verify
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PosInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.cards != null && message.hasOwnProperty("cards")) {
                    if (!Array.isArray(message.cards))
                        return "cards: array expected";
                    for (var i = 0; i < message.cards.length; ++i)
                        if (!$util.isInteger(message.cards[i]))
                            return "cards: integer[] expected";
                }
                if (message.cardPoint != null && message.hasOwnProperty("cardPoint")) {
                    if (!Array.isArray(message.cardPoint))
                        return "cardPoint: array expected";
                    for (var i = 0; i < message.cardPoint.length; ++i)
                        if (!$util.isInteger(message.cardPoint[i]))
                            return "cardPoint: integer[] expected";
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.bet != null && message.hasOwnProperty("bet"))
                    if (typeof message.bet !== "number")
                        return "bet: number expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                if (message.balance != null && message.hasOwnProperty("balance"))
                    if (typeof message.balance !== "number")
                        return "balance: number expected";
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    if (typeof message.totalBalance !== "number")
                        return "totalBalance: number expected";
                return null;
            };

            /**
             * Creates a PosInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.GameSettle.PosInfo} PosInfo
             */
            PosInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.GameSettle.PosInfo)
                    return object;
                var message = new $root.BlackJack.GameSettle.PosInfo();
                if (object.pos != null)
                    message.pos = object.pos >>> 0;
                if (object.cards) {
                    if (!Array.isArray(object.cards))
                        throw TypeError(".BlackJack.GameSettle.PosInfo.cards: array expected");
                    message.cards = [];
                    for (var i = 0; i < object.cards.length; ++i)
                        message.cards[i] = object.cards[i] | 0;
                }
                if (object.cardPoint) {
                    if (!Array.isArray(object.cardPoint))
                        throw TypeError(".BlackJack.GameSettle.PosInfo.cardPoint: array expected");
                    message.cardPoint = [];
                    for (var i = 0; i < object.cardPoint.length; ++i)
                        message.cardPoint[i] = object.cardPoint[i] | 0;
                }
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.bet != null)
                    message.bet = Number(object.bet);
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                if (object.balance != null)
                    message.balance = Number(object.balance);
                if (object.totalBalance != null)
                    message.totalBalance = Number(object.totalBalance);
                return message;
            };

            /**
             * Creates a plain object from a PosInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.GameSettle.PosInfo
             * @static
             * @param {BlackJack.GameSettle.PosInfo} message PosInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PosInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.cardPoint = [];
                    object.cards = [];
                }
                if (options.defaults) {
                    object.pos = 0;
                    object.playerId = 0;
                    object.balance = 0;
                    object.bet = 0;
                    object.totalBalance = 0;
                    object.coinBalance = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.cardPoint && message.cardPoint.length) {
                    object.cardPoint = [];
                    for (var j = 0; j < message.cardPoint.length; ++j)
                        object.cardPoint[j] = message.cardPoint[j];
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                if (message.cards && message.cards.length) {
                    object.cards = [];
                    for (var j = 0; j < message.cards.length; ++j)
                        object.cards[j] = message.cards[j];
                }
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    object.totalBalance = options.json && !isFinite(message.totalBalance) ? String(message.totalBalance) : message.totalBalance;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                return object;
            };

            /**
             * Converts this PosInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.GameSettle.PosInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PosInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PosInfo;
        })();

        GameSettle.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof BlackJack.GameSettle
             * @interface IPlayer
             * @property {number|null} [playerId] Player playerId
             * @property {number|null} [pos] Player pos
             * @property {number|null} [coinBalance] Player coinBalance
             * @property {number|null} [bet] Player bet
             * @property {number|null} [currentCoinBalance] Player currentCoinBalance
             * @property {number|null} [totalBalance] Player totalBalance
             */

            /**
             * Constructs a new Player.
             * @memberof BlackJack.GameSettle
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {BlackJack.GameSettle.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player playerId.
             * @member {number} playerId
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.playerId = 0;

            /**
             * Player pos.
             * @member {number} pos
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.pos = 0;

            /**
             * Player coinBalance.
             * @member {number} coinBalance
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.coinBalance = 0;

            /**
             * Player bet.
             * @member {number} bet
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.bet = 0;

            /**
             * Player currentCoinBalance.
             * @member {number} currentCoinBalance
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.currentCoinBalance = 0;

            /**
             * Player totalBalance.
             * @member {number} totalBalance
             * @memberof BlackJack.GameSettle.Player
             * @instance
             */
            Player.prototype.totalBalance = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {BlackJack.GameSettle.IPlayer=} [properties] Properties to set
             * @returns {BlackJack.GameSettle.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link BlackJack.GameSettle.Player.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {BlackJack.GameSettle.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.pos);
                if (message.bet != null && message.hasOwnProperty("bet"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.bet);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.coinBalance);
                if (message.currentCoinBalance != null && message.hasOwnProperty("currentCoinBalance"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.currentCoinBalance);
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.totalBalance);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link BlackJack.GameSettle.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {BlackJack.GameSettle.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.GameSettle.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.GameSettle.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.pos = reader.uint32();
                        break;
                    case 4:
                        message.coinBalance = reader.double();
                        break;
                    case 3:
                        message.bet = reader.double();
                        break;
                    case 5:
                        message.currentCoinBalance = reader.double();
                        break;
                    case 7:
                        message.totalBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.GameSettle.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                if (message.bet != null && message.hasOwnProperty("bet"))
                    if (typeof message.bet !== "number")
                        return "bet: number expected";
                if (message.currentCoinBalance != null && message.hasOwnProperty("currentCoinBalance"))
                    if (typeof message.currentCoinBalance !== "number")
                        return "currentCoinBalance: number expected";
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    if (typeof message.totalBalance !== "number")
                        return "totalBalance: number expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.GameSettle.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.GameSettle.Player)
                    return object;
                var message = new $root.BlackJack.GameSettle.Player();
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.pos != null)
                    message.pos = object.pos >>> 0;
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                if (object.bet != null)
                    message.bet = Number(object.bet);
                if (object.currentCoinBalance != null)
                    message.currentCoinBalance = Number(object.currentCoinBalance);
                if (object.totalBalance != null)
                    message.totalBalance = Number(object.totalBalance);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.GameSettle.Player
             * @static
             * @param {BlackJack.GameSettle.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.playerId = 0;
                    object.pos = 0;
                    object.bet = 0;
                    object.coinBalance = 0;
                    object.currentCoinBalance = 0;
                    object.totalBalance = 0;
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                if (message.currentCoinBalance != null && message.hasOwnProperty("currentCoinBalance"))
                    object.currentCoinBalance = options.json && !isFinite(message.currentCoinBalance) ? String(message.currentCoinBalance) : message.currentCoinBalance;
                if (message.totalBalance != null && message.hasOwnProperty("totalBalance"))
                    object.totalBalance = options.json && !isFinite(message.totalBalance) ? String(message.totalBalance) : message.totalBalance;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof BlackJack.GameSettle.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return GameSettle;
    })();

    BlackJack.TimeoutNotify = (function() {

        /**
         * Properties of a TimeoutNotify.
         * @memberof BlackJack
         * @interface ITimeoutNotify
         * @property {number|null} [timeout] TimeoutNotify timeout
         * @property {number|null} [event] TimeoutNotify event
         * @property {number|null} [ackId] TimeoutNotify ackId
         * @property {number|null} [pos] TimeoutNotify pos
         * @property {BlackJack.TimeoutNotify.IBetInfo|null} [lastBetInfo] TimeoutNotify lastBetInfo
         * @property {number|null} [totalTimeout] TimeoutNotify totalTimeout
         */

        /**
         * Constructs a new TimeoutNotify.
         * @memberof BlackJack
         * @classdesc Represents a TimeoutNotify.
         * @implements ITimeoutNotify
         * @constructor
         * @param {BlackJack.ITimeoutNotify=} [properties] Properties to set
         */
        function TimeoutNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeoutNotify timeout.
         * @member {number} timeout
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.timeout = 0;

        /**
         * TimeoutNotify event.
         * @member {number} event
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.event = 0;

        /**
         * TimeoutNotify ackId.
         * @member {number} ackId
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.ackId = 0;

        /**
         * TimeoutNotify pos.
         * @member {number} pos
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.pos = 0;

        /**
         * TimeoutNotify lastBetInfo.
         * @member {BlackJack.TimeoutNotify.IBetInfo|null|undefined} lastBetInfo
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.lastBetInfo = null;

        /**
         * TimeoutNotify totalTimeout.
         * @member {number} totalTimeout
         * @memberof BlackJack.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.totalTimeout = 0;

        /**
         * Creates a new TimeoutNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {BlackJack.ITimeoutNotify=} [properties] Properties to set
         * @returns {BlackJack.TimeoutNotify} TimeoutNotify instance
         */
        TimeoutNotify.create = function create(properties) {
            return new TimeoutNotify(properties);
        };

        /**
         * Encodes the specified TimeoutNotify message. Does not implicitly {@link BlackJack.TimeoutNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {BlackJack.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.timeout);
            if (message.event != null && message.hasOwnProperty("event"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.event);
            if (message.pos != null && message.hasOwnProperty("pos"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.pos);
            if (message.lastBetInfo != null && message.hasOwnProperty("lastBetInfo"))
                $root.BlackJack.TimeoutNotify.BetInfo.encode(message.lastBetInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalTimeout);
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified TimeoutNotify message, length delimited. Does not implicitly {@link BlackJack.TimeoutNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {BlackJack.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.TimeoutNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.timeout = reader.int32();
                    break;
                case 2:
                    message.event = reader.int32();
                    break;
                case 6:
                    message.ackId = reader.int32();
                    break;
                case 3:
                    message.pos = reader.uint32();
                    break;
                case 4:
                    message.lastBetInfo = $root.BlackJack.TimeoutNotify.BetInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalTimeout = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeoutNotify message.
         * @function verify
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeoutNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                if (!$util.isInteger(message.timeout))
                    return "timeout: integer expected";
            if (message.event != null && message.hasOwnProperty("event"))
                if (!$util.isInteger(message.event))
                    return "event: integer expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            if (message.pos != null && message.hasOwnProperty("pos"))
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
            if (message.lastBetInfo != null && message.hasOwnProperty("lastBetInfo")) {
                var error = $root.BlackJack.TimeoutNotify.BetInfo.verify(message.lastBetInfo);
                if (error)
                    return "lastBetInfo." + error;
            }
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                if (!$util.isInteger(message.totalTimeout))
                    return "totalTimeout: integer expected";
            return null;
        };

        /**
         * Creates a TimeoutNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.TimeoutNotify} TimeoutNotify
         */
        TimeoutNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.TimeoutNotify)
                return object;
            var message = new $root.BlackJack.TimeoutNotify();
            if (object.timeout != null)
                message.timeout = object.timeout | 0;
            if (object.event != null)
                message.event = object.event | 0;
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            if (object.pos != null)
                message.pos = object.pos >>> 0;
            if (object.lastBetInfo != null) {
                if (typeof object.lastBetInfo !== "object")
                    throw TypeError(".BlackJack.TimeoutNotify.lastBetInfo: object expected");
                message.lastBetInfo = $root.BlackJack.TimeoutNotify.BetInfo.fromObject(object.lastBetInfo);
            }
            if (object.totalTimeout != null)
                message.totalTimeout = object.totalTimeout | 0;
            return message;
        };

        /**
         * Creates a plain object from a TimeoutNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.TimeoutNotify
         * @static
         * @param {BlackJack.TimeoutNotify} message TimeoutNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeoutNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timeout = 0;
                object.event = 0;
                object.pos = 0;
                object.lastBetInfo = null;
                object.totalTimeout = 0;
                object.ackId = 0;
            }
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                object.timeout = message.timeout;
            if (message.event != null && message.hasOwnProperty("event"))
                object.event = message.event;
            if (message.pos != null && message.hasOwnProperty("pos"))
                object.pos = message.pos;
            if (message.lastBetInfo != null && message.hasOwnProperty("lastBetInfo"))
                object.lastBetInfo = $root.BlackJack.TimeoutNotify.BetInfo.toObject(message.lastBetInfo, options);
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                object.totalTimeout = message.totalTimeout;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this TimeoutNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.TimeoutNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeoutNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TimeoutNotify.BetInfo = (function() {

            /**
             * Properties of a BetInfo.
             * @memberof BlackJack.TimeoutNotify
             * @interface IBetInfo
             * @property {number|null} [pos] BetInfo pos
             * @property {number|null} [base] BetInfo base
             * @property {number|null} [pair] BetInfo pair
             * @property {number|null} [b21p3] BetInfo b21p3
             */

            /**
             * Constructs a new BetInfo.
             * @memberof BlackJack.TimeoutNotify
             * @classdesc Represents a BetInfo.
             * @implements IBetInfo
             * @constructor
             * @param {BlackJack.TimeoutNotify.IBetInfo=} [properties] Properties to set
             */
            function BetInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BetInfo pos.
             * @member {number} pos
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.pos = 0;

            /**
             * BetInfo base.
             * @member {number} base
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.base = 0;

            /**
             * BetInfo pair.
             * @member {number} pair
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.pair = 0;

            /**
             * BetInfo b21p3.
             * @member {number} b21p3
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @instance
             */
            BetInfo.prototype.b21p3 = 0;

            /**
             * Creates a new BetInfo instance using the specified properties.
             * @function create
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {BlackJack.TimeoutNotify.IBetInfo=} [properties] Properties to set
             * @returns {BlackJack.TimeoutNotify.BetInfo} BetInfo instance
             */
            BetInfo.create = function create(properties) {
                return new BetInfo(properties);
            };

            /**
             * Encodes the specified BetInfo message. Does not implicitly {@link BlackJack.TimeoutNotify.BetInfo.verify|verify} messages.
             * @function encode
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {BlackJack.TimeoutNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pos);
                if (message.base != null && message.hasOwnProperty("base"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.base);
                if (message.pair != null && message.hasOwnProperty("pair"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.pair);
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.b21p3);
                return writer;
            };

            /**
             * Encodes the specified BetInfo message, length delimited. Does not implicitly {@link BlackJack.TimeoutNotify.BetInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {BlackJack.TimeoutNotify.IBetInfo} message BetInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer.
             * @function decode
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {BlackJack.TimeoutNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.TimeoutNotify.BetInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.uint32();
                        break;
                    case 2:
                        message.base = reader.double();
                        break;
                    case 3:
                        message.pair = reader.double();
                        break;
                    case 4:
                        message.b21p3 = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BetInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {BlackJack.TimeoutNotify.BetInfo} BetInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BetInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BetInfo message.
             * @function verify
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BetInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.base != null && message.hasOwnProperty("base"))
                    if (typeof message.base !== "number")
                        return "base: number expected";
                if (message.pair != null && message.hasOwnProperty("pair"))
                    if (typeof message.pair !== "number")
                        return "pair: number expected";
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    if (typeof message.b21p3 !== "number")
                        return "b21p3: number expected";
                return null;
            };

            /**
             * Creates a BetInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {BlackJack.TimeoutNotify.BetInfo} BetInfo
             */
            BetInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.BlackJack.TimeoutNotify.BetInfo)
                    return object;
                var message = new $root.BlackJack.TimeoutNotify.BetInfo();
                if (object.pos != null)
                    message.pos = object.pos >>> 0;
                if (object.base != null)
                    message.base = Number(object.base);
                if (object.pair != null)
                    message.pair = Number(object.pair);
                if (object.b21p3 != null)
                    message.b21p3 = Number(object.b21p3);
                return message;
            };

            /**
             * Creates a plain object from a BetInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @static
             * @param {BlackJack.TimeoutNotify.BetInfo} message BetInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BetInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.pos = 0;
                    object.base = 0;
                    object.pair = 0;
                    object.b21p3 = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.base != null && message.hasOwnProperty("base"))
                    object.base = options.json && !isFinite(message.base) ? String(message.base) : message.base;
                if (message.pair != null && message.hasOwnProperty("pair"))
                    object.pair = options.json && !isFinite(message.pair) ? String(message.pair) : message.pair;
                if (message.b21p3 != null && message.hasOwnProperty("b21p3"))
                    object.b21p3 = options.json && !isFinite(message.b21p3) ? String(message.b21p3) : message.b21p3;
                return object;
            };

            /**
             * Converts this BetInfo to JSON.
             * @function toJSON
             * @memberof BlackJack.TimeoutNotify.BetInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BetInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BetInfo;
        })();

        return TimeoutNotify;
    })();

    BlackJack.AckReq = (function() {

        /**
         * Properties of an AckReq.
         * @memberof BlackJack
         * @interface IAckReq
         * @property {number|null} [ackId] AckReq ackId
         */

        /**
         * Constructs a new AckReq.
         * @memberof BlackJack
         * @classdesc Represents an AckReq.
         * @implements IAckReq
         * @constructor
         * @param {BlackJack.IAckReq=} [properties] Properties to set
         */
        function AckReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AckReq ackId.
         * @member {number} ackId
         * @memberof BlackJack.AckReq
         * @instance
         */
        AckReq.prototype.ackId = 0;

        /**
         * Creates a new AckReq instance using the specified properties.
         * @function create
         * @memberof BlackJack.AckReq
         * @static
         * @param {BlackJack.IAckReq=} [properties] Properties to set
         * @returns {BlackJack.AckReq} AckReq instance
         */
        AckReq.create = function create(properties) {
            return new AckReq(properties);
        };

        /**
         * Encodes the specified AckReq message. Does not implicitly {@link BlackJack.AckReq.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.AckReq
         * @static
         * @param {BlackJack.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified AckReq message, length delimited. Does not implicitly {@link BlackJack.AckReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.AckReq
         * @static
         * @param {BlackJack.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.AckReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ackId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AckReq message.
         * @function verify
         * @memberof BlackJack.AckReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AckReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            return null;
        };

        /**
         * Creates an AckReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.AckReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.AckReq} AckReq
         */
        AckReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.AckReq)
                return object;
            var message = new $root.BlackJack.AckReq();
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            return message;
        };

        /**
         * Creates a plain object from an AckReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.AckReq
         * @static
         * @param {BlackJack.AckReq} message AckReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AckReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ackId = 0;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this AckReq to JSON.
         * @function toJSON
         * @memberof BlackJack.AckReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AckReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AckReq;
    })();

    BlackJack.NoBetNotify = (function() {

        /**
         * Properties of a NoBetNotify.
         * @memberof BlackJack
         * @interface INoBetNotify
         * @property {number} playerId NoBetNotify playerId
         * @property {number} seatId NoBetNotify seatId
         * @property {number} noBetCnt NoBetNotify noBetCnt
         */

        /**
         * Constructs a new NoBetNotify.
         * @memberof BlackJack
         * @classdesc Represents a NoBetNotify.
         * @implements INoBetNotify
         * @constructor
         * @param {BlackJack.INoBetNotify=} [properties] Properties to set
         */
        function NoBetNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NoBetNotify playerId.
         * @member {number} playerId
         * @memberof BlackJack.NoBetNotify
         * @instance
         */
        NoBetNotify.prototype.playerId = 0;

        /**
         * NoBetNotify seatId.
         * @member {number} seatId
         * @memberof BlackJack.NoBetNotify
         * @instance
         */
        NoBetNotify.prototype.seatId = 0;

        /**
         * NoBetNotify noBetCnt.
         * @member {number} noBetCnt
         * @memberof BlackJack.NoBetNotify
         * @instance
         */
        NoBetNotify.prototype.noBetCnt = 0;

        /**
         * Creates a new NoBetNotify instance using the specified properties.
         * @function create
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {BlackJack.INoBetNotify=} [properties] Properties to set
         * @returns {BlackJack.NoBetNotify} NoBetNotify instance
         */
        NoBetNotify.create = function create(properties) {
            return new NoBetNotify(properties);
        };

        /**
         * Encodes the specified NoBetNotify message. Does not implicitly {@link BlackJack.NoBetNotify.verify|verify} messages.
         * @function encode
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {BlackJack.INoBetNotify} message NoBetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoBetNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seatId);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.noBetCnt);
            return writer;
        };

        /**
         * Encodes the specified NoBetNotify message, length delimited. Does not implicitly {@link BlackJack.NoBetNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {BlackJack.INoBetNotify} message NoBetNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NoBetNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NoBetNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BlackJack.NoBetNotify} NoBetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoBetNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlackJack.NoBetNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.seatId = reader.int32();
                    break;
                case 3:
                    message.noBetCnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("seatId"))
                throw $util.ProtocolError("missing required 'seatId'", { instance: message });
            if (!message.hasOwnProperty("noBetCnt"))
                throw $util.ProtocolError("missing required 'noBetCnt'", { instance: message });
            return message;
        };

        /**
         * Decodes a NoBetNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BlackJack.NoBetNotify} NoBetNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NoBetNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NoBetNotify message.
         * @function verify
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NoBetNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.seatId))
                return "seatId: integer expected";
            if (!$util.isInteger(message.noBetCnt))
                return "noBetCnt: integer expected";
            return null;
        };

        /**
         * Creates a NoBetNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BlackJack.NoBetNotify} NoBetNotify
         */
        NoBetNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BlackJack.NoBetNotify)
                return object;
            var message = new $root.BlackJack.NoBetNotify();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.seatId != null)
                message.seatId = object.seatId | 0;
            if (object.noBetCnt != null)
                message.noBetCnt = object.noBetCnt | 0;
            return message;
        };

        /**
         * Creates a plain object from a NoBetNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BlackJack.NoBetNotify
         * @static
         * @param {BlackJack.NoBetNotify} message NoBetNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NoBetNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.seatId = 0;
                object.noBetCnt = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.seatId != null && message.hasOwnProperty("seatId"))
                object.seatId = message.seatId;
            if (message.noBetCnt != null && message.hasOwnProperty("noBetCnt"))
                object.noBetCnt = message.noBetCnt;
            return object;
        };

        /**
         * Converts this NoBetNotify to JSON.
         * @function toJSON
         * @memberof BlackJack.NoBetNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NoBetNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NoBetNotify;
    })();

    return BlackJack;
})();

module.exports = $root;
